// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

import {
    type Client,
    type ClientMeta,
    formDataBodySerializer,
    type Options as Options2,
    type RequestResult,
    type TDataShape,
} from './client';
import { client } from './client.gen';
import type {
    ApproveContractBonusData,
    ApproveContractBonusErrors,
    ApproveContractBonusResponses,
    ApproveContractRaiseData,
    ApproveContractRaiseErrors,
    ApproveContractRaiseResponses,
    ApproveOpsApprovalData,
    ApproveOpsApprovalErrors,
    ApproveOpsApprovalResponses,
    AssignContractingEntityData,
    AssignContractingEntityErrors,
    AssignContractingEntityResponses,
    ChangeCountryData,
    ChangeCountryErrors,
    ChangeCountryResponses,
    ChangeLegalNameData,
    ChangeLegalNameErrors,
    ChangeLegalNameResponses,
    CheckBankAccountNameData,
    CheckBankAccountNameErrors,
    CheckBankAccountNameResponses,
    CheckrWebhookData,
    CheckrWebhookErrors,
    CheckrWebhookResponses,
    CompleteCustomerCheckinData,
    CompleteCustomerCheckinErrors,
    CompleteCustomerCheckinResponses,
    ConfirmEquipmentQuoteShippingInfoData,
    ConfirmEquipmentQuoteShippingInfoErrors,
    ConfirmEquipmentQuoteShippingInfoResponses,
    ConfirmUserShippingInfoData,
    ConfirmUserShippingInfoErrors,
    ConfirmUserShippingInfoResponses,
    CreateBankAccountData,
    CreateBankAccountErrors,
    CreateBankAccountResponses,
    CreateContractBonusData,
    CreateContractBonusErrors,
    CreateContractBonusResponses,
    CreateContractingEntityData,
    CreateContractingEntityErrors,
    CreateContractingEntityResponses,
    CreateContractRaiseData,
    CreateContractRaiseErrors,
    CreateContractRaiseResponses,
    CreateCustomerGroupData,
    CreateCustomerGroupErrors,
    CreateCustomerGroupResponses,
    CreateCustomerUserData,
    CreateCustomerUserErrors,
    CreateCustomerUserResponses,
    CreateEquipmentData,
    CreateEquipmentErrors,
    CreateEquipmentResponses,
    DeleteBankAccountData,
    DeleteBankAccountErrors,
    DeleteBankAccountResponses,
    DeleteContractorInvoiceData,
    DeleteContractorInvoiceErrors,
    DeleteContractorInvoiceResponses,
    DeleteCustomerGroupData,
    DeleteCustomerGroupErrors,
    DeleteCustomerGroupResponses,
    DeleteCustomerInvoiceData,
    DeleteCustomerInvoiceErrors,
    DeleteCustomerInvoiceResponses,
    ExpandJobData,
    ExpandJobErrors,
    ExpandJobResponses,
    FinishCandidateProfileBuilderData,
    FinishCandidateProfileBuilderErrors,
    FinishCandidateProfileBuilderResponses,
    GetAiInterviewConfigData,
    GetAiInterviewConfigErrors,
    GetAiInterviewConfigResponses,
    GetApplicationFitData,
    GetApplicationFitErrors,
    GetApplicationFitResponses,
    GetBankAccountData,
    GetBankAccountErrors,
    GetBankAccountResponses,
    GetCandidateCertificationHistoryData,
    GetCandidateCertificationHistoryErrors,
    GetCandidateCertificationHistoryResponses,
    GetCandidateExpectedSalaryHistoryData,
    GetCandidateExpectedSalaryHistoryErrors,
    GetCandidateExpectedSalaryHistoryResponses,
    GetCandidateExperimentsHistoryData,
    GetCandidateExperimentsHistoryErrors,
    GetCandidateExperimentsHistoryResponses,
    GetCandidateOpenToOpportunitiesHistoryData,
    GetCandidateOpenToOpportunitiesHistoryErrors,
    GetCandidateOpenToOpportunitiesHistoryResponses,
    GetCandidateProfileBuilderWorkHistoryData,
    GetCandidateProfileBuilderWorkHistoryErrors,
    GetCandidateProfileBuilderWorkHistoryResponses,
    GetCandidateProfileCompleteHistoryData,
    GetCandidateProfileCompleteHistoryErrors,
    GetCandidateProfileCompleteHistoryResponses,
    GetCandidateProfileUpdateBookingUrlData,
    GetCandidateProfileUpdateBookingUrlErrors,
    GetCandidateProfileUpdateBookingUrlResponses,
    GetCandidateSeniorityHistoryData,
    GetCandidateSeniorityHistoryErrors,
    GetCandidateSeniorityHistoryResponses,
    GetCandidateSourceHistoryData,
    GetCandidateSourceHistoryErrors,
    GetCandidateSourceHistoryResponses,
    GetCandidateStatusHistoryData,
    GetCandidateStatusHistoryErrors,
    GetCandidateStatusHistoryResponses,
    GetCandidateWorkExperienceHistoryData,
    GetCandidateWorkExperienceHistoryErrors,
    GetCandidateWorkExperienceHistoryResponses,
    GetContractData,
    GetContractErrors,
    GetContractingEntityData,
    GetContractingEntityErrors,
    GetContractingEntityResponses,
    GetContractingEntitySelectionData,
    GetContractingEntitySelectionErrors,
    GetContractingEntitySelectionResponses,
    GetContractingEntitySelectionStatusData,
    GetContractingEntitySelectionStatusErrors,
    GetContractingEntitySelectionStatusResponses,
    GetContractorCheckinData,
    GetContractorCheckinErrors,
    GetContractorCheckinResponses,
    GetContractorEmploymentInfoData,
    GetContractorEmploymentInfoErrors,
    GetContractorEmploymentInfoResponses,
    GetContractorHealthData,
    GetContractorHealthErrors,
    GetContractorHealthHistoryData,
    GetContractorHealthHistoryErrors,
    GetContractorHealthHistoryResponses,
    GetContractorHealthResponses,
    GetContractorPersonalInfoData,
    GetContractorPersonalInfoErrors,
    GetContractorPersonalInfoResponses,
    GetContractResponses,
    GetCustomerBasicProfileData,
    GetCustomerBasicProfileErrors,
    GetCustomerBasicProfileResponses,
    GetCustomerBillingDataData,
    GetCustomerBillingDataErrors,
    GetCustomerBillingDataResponses,
    GetCustomerGroupData,
    GetCustomerGroupErrors,
    GetCustomerGroupResponses,
    GetCustomerPoliciesBenefitsData,
    GetCustomerPoliciesBenefitsErrors,
    GetCustomerPoliciesBenefitsResponses,
    GetCustomerProfileData,
    GetCustomerProfileErrors,
    GetCustomerProfileResponses,
    GetCustomerStageHistoryData,
    GetCustomerStageHistoryErrors,
    GetCustomerStageHistoryResponses,
    GetCustomerUserResponsibilitiesData,
    GetCustomerUserResponsibilitiesErrors,
    GetCustomerUserResponsibilitiesResponses,
    GetEquipmentData,
    GetEquipmentErrors,
    GetEquipmentQuoteShippingInfoData,
    GetEquipmentQuoteShippingInfoErrors,
    GetEquipmentQuoteShippingInfoResponses,
    GetEquipmentResponses,
    GetHealthInsurancePlanData,
    GetHealthInsurancePlanErrors,
    GetHealthInsurancePlanResponses,
    GetJobExpansionPreviewData,
    GetJobExpansionPreviewErrors,
    GetJobExpansionPreviewResponses,
    GetJobOpeningCompanyOwnerHistoryData,
    GetJobOpeningCompanyOwnerHistoryErrors,
    GetJobOpeningCompanyOwnerHistoryResponses,
    GetJobOpeningHealthHistoryData,
    GetJobOpeningHealthHistoryErrors,
    GetJobOpeningHealthHistoryResponses,
    GetLocationData,
    GetLocationErrors,
    GetLocationResponses,
    GetOpsApprovalData,
    GetOpsApprovalErrors,
    GetOpsApprovalResponses,
    GetPaymentAttemptHistoryData,
    GetPaymentAttemptHistoryErrors,
    GetPaymentAttemptHistoryResponses,
    GetPublicCustomerProfileData,
    GetPublicCustomerProfileErrors,
    GetPublicCustomerProfileResponses,
    GetUserCertificationsData,
    GetUserCertificationsErrors,
    GetUserCertificationsResponses,
    GetUserContactInfoData,
    GetUserContactInfoErrors,
    GetUserContactInfoResponses,
    GetUserJobDetailsData,
    GetUserJobDetailsErrors,
    GetUserJobDetailsResponses,
    GetUserPendingChangesData,
    GetUserPendingChangesErrors,
    GetUserPendingChangesResponses,
    GetUserPersonalInfoData,
    GetUserPersonalInfoErrors,
    GetUserPersonalInfoResponses,
    GetUserProfileData,
    GetUserProfileErrors,
    GetUserProfileResponses,
    GetUserSchedulingUrlData,
    GetUserSchedulingUrlErrors,
    GetUserSchedulingUrlResponses,
    GetUserSeniorityData,
    GetUserSeniorityErrors,
    GetUserSeniorityResponses,
    GetUserShippingInfoData,
    GetUserShippingInfoErrors,
    GetUserShippingInfoResponses,
    GetUserWorkInfoData,
    GetUserWorkInfoErrors,
    GetUserWorkInfoResponses,
    GetUserWorkProfileData,
    GetUserWorkProfileErrors,
    GetUserWorkProfileResponses,
    HandleCspReportData,
    HandleCspReportErrors,
    HandleCspReportResponses,
    ImBulkPreflightData,
    ImBulkPreflightErrors,
    ImBulkPreflightResponses,
    ImBulkSendData,
    ImBulkSendErrors,
    ImBulkSendResponses,
    InitAiInterviewData,
    InitAiInterviewErrors,
    InitAiInterviewResponses,
    ListBackgroundCheckPricingData,
    ListBackgroundCheckPricingErrors,
    ListBackgroundCheckPricingResponses,
    ListBackgroundChecksData,
    ListBackgroundChecksErrors,
    ListBackgroundChecksResponses,
    ListBankAccountsData,
    ListBankAccountsErrors,
    ListBankAccountsResponses,
    ListContractBonusesData,
    ListContractBonusesErrors,
    ListContractBonusesResponses,
    ListContractingEntitiesData,
    ListContractingEntitiesErrors,
    ListContractingEntitiesResponses,
    ListContractRaisesData,
    ListContractRaisesErrors,
    ListContractRaisesResponses,
    ListCustomerGroupApproversData,
    ListCustomerGroupApproversErrors,
    ListCustomerGroupApproversResponses,
    ListCustomerGroupsData,
    ListCustomerGroupsErrors,
    ListCustomerGroupsResponses,
    ListCustomerInvoicesData,
    ListCustomerInvoicesErrors,
    ListCustomerInvoicesResponses,
    ListCustomerUsersData,
    ListCustomerUsersErrors,
    ListCustomerUsersResponses,
    ListOpsApprovalsData,
    ListOpsApprovalsErrors,
    ListOpsApprovalsResponses,
    ListUserBankAccountsData,
    ListUserBankAccountsErrors,
    ListUserBankAccountsResponses,
    ListUserContractingEntitiesData,
    ListUserContractingEntitiesErrors,
    ListUserContractingEntitiesResponses,
    ListUserContractsData,
    ListUserContractsErrors,
    ListUserContractsResponses,
    ListUserDocumentsData,
    ListUserDocumentsErrors,
    ListUserDocumentsResponses,
    PayContractorInvoiceData,
    PayContractorInvoiceErrors,
    PayContractorInvoiceResponses,
    ReassignCustomerUserResponsibilitiesData,
    ReassignCustomerUserResponsibilitiesErrors,
    ReassignCustomerUserResponsibilitiesResponses,
    RecordEquipmentQuoteApprovalData,
    RecordEquipmentQuoteApprovalErrors,
    RecordEquipmentQuoteApprovalResponses,
    RegenerateContractorInvoiceData,
    RegenerateContractorInvoiceErrors,
    RegenerateContractorInvoiceResponses,
    RegenerateCustomerInvoiceData,
    RegenerateCustomerInvoiceErrors,
    RegenerateCustomerInvoiceResponses,
    RejectContractBonusData,
    RejectContractBonusErrors,
    RejectContractBonusResponses,
    RejectContractRaiseData,
    RejectContractRaiseErrors,
    RejectContractRaiseResponses,
    RejectOpsApprovalData,
    RejectOpsApprovalErrors,
    RejectOpsApprovalResponses,
    RequestCandidateProfileUpdateData,
    RequestCandidateProfileUpdateErrors,
    RequestCandidateProfileUpdateResponses,
    RequestContractingEntitySelectionData,
    RequestContractingEntitySelectionErrors,
    RequestContractingEntitySelectionResponses,
    RequestSalaryChangeData,
    RequestSalaryChangeErrors,
    RequestSalaryChangeResponses,
    RequestUserDeletionData,
    RequestUserDeletionErrors,
    RequestUserDeletionResponses,
    RescoreApplicationData,
    RescoreApplicationErrors,
    RescoreApplicationResponses,
    RescoreProspectData,
    RescoreProspectErrors,
    RescoreProspectResponses,
    ReviewApplicationFitData,
    ReviewApplicationFitErrors,
    ReviewApplicationFitResponses,
    ReviewCandidateVerificationData,
    ReviewCandidateVerificationErrors,
    ReviewCandidateVerificationResponses,
    ScheduleContractorCheckinMeetingData,
    ScheduleContractorCheckinMeetingErrors,
    ScheduleContractorCheckinMeetingResponses,
    SearchApplicantsData,
    SearchApplicantsErrors,
    SearchApplicantsResponses,
    SearchCandidatesData,
    SearchCandidatesErrors,
    SearchCandidatesResponses,
    SearchContractorsData,
    SearchContractorsErrors,
    SearchContractorsResponses,
    SearchCustomerContractorsData,
    SearchCustomerContractorsErrors,
    SearchCustomerContractorsResponses,
    SearchCustomersData,
    SearchCustomersErrors,
    SearchCustomersResponses,
    SelectExistingContractingEntityData,
    SelectExistingContractingEntityErrors,
    SelectExistingContractingEntityResponses,
    SelectNewContractingEntityData,
    SelectNewContractingEntityErrors,
    SelectNewContractingEntityResponses,
    SetCustomerStatusData,
    SetCustomerStatusErrors,
    SetCustomerStatusResponses,
    SetCustomerUserStatusData,
    SetCustomerUserStatusErrors,
    SetCustomerUserStatusResponses,
    SetCustomerVisibilityData,
    SetCustomerVisibilityErrors,
    SetCustomerVisibilityResponses,
    SetDefaultBankAccountData,
    SetDefaultBankAccountErrors,
    SetDefaultBankAccountResponses,
    StartCandidateProfileBuilderData,
    StartCandidateProfileBuilderErrors,
    StartCandidateProfileBuilderResponses,
    UndoContractTerminationData,
    UndoContractTerminationErrors,
    UndoContractTerminationResponses,
    UpdateBankAccountData,
    UpdateBankAccountErrors,
    UpdateBankAccountResponses,
    UpdateCandidatePersonalInfoData,
    UpdateCandidatePersonalInfoErrors,
    UpdateCandidatePersonalInfoResponses,
    UpdateContractData,
    UpdateContractErrors,
    UpdateContractingEntityData,
    UpdateContractingEntityErrors,
    UpdateContractingEntityResponses,
    UpdateContractorEmploymentInfoData,
    UpdateContractorEmploymentInfoErrors,
    UpdateContractorEmploymentInfoResponses,
    UpdateContractorHealthData,
    UpdateContractorHealthErrors,
    UpdateContractorHealthResponses,
    UpdateContractorInvoiceAccountData,
    UpdateContractorInvoiceAccountErrors,
    UpdateContractorInvoiceAccountResponses,
    UpdateContractorInvoiceStatusData,
    UpdateContractorInvoiceStatusErrors,
    UpdateContractorInvoiceStatusResponses,
    UpdateContractResponses,
    UpdateCustomerBillingAddressData,
    UpdateCustomerBillingAddressErrors,
    UpdateCustomerBillingAddressResponses,
    UpdateCustomerBillingContactsData,
    UpdateCustomerBillingContactsErrors,
    UpdateCustomerBillingContactsResponses,
    UpdateCustomerBillingDetailsData,
    UpdateCustomerBillingDetailsErrors,
    UpdateCustomerBillingDetailsResponses,
    UpdateCustomerDetailsData,
    UpdateCustomerDetailsErrors,
    UpdateCustomerDetailsResponses,
    UpdateCustomerGroupData,
    UpdateCustomerGroupErrors,
    UpdateCustomerGroupResponses,
    UpdateCustomerInvoiceStatusData,
    UpdateCustomerInvoiceStatusErrors,
    UpdateCustomerInvoiceStatusResponses,
    UpdateCustomerPoliciesBenefitsData,
    UpdateCustomerPoliciesBenefitsErrors,
    UpdateCustomerPoliciesBenefitsResponses,
    UpdateCustomerSectionData,
    UpdateCustomerSectionErrors,
    UpdateCustomerSectionResponses,
    UpdateCustomerTalentPreferencesData,
    UpdateCustomerTalentPreferencesErrors,
    UpdateCustomerTalentPreferencesResponses,
    UpdateCustomerUserData,
    UpdateCustomerUserErrors,
    UpdateCustomerUserResponses,
    UpdateEquipmentData,
    UpdateEquipmentErrors,
    UpdateEquipmentResponses,
    UpdateLocationData,
    UpdateLocationErrors,
    UpdateLocationResponses,
    UpdateProfileData,
    UpdateProfileErrors,
    UpdateProfileResponses,
    UpdateUserCertificationsData,
    UpdateUserCertificationsErrors,
    UpdateUserCertificationsResponses,
    UpdateUserContactInfoData,
    UpdateUserContactInfoErrors,
    UpdateUserContactInfoResponses,
    UpdateUserPersonalInfoData,
    UpdateUserPersonalInfoErrors,
    UpdateUserPersonalInfoResponses,
    UpdateUserSchedulingUrlData,
    UpdateUserSchedulingUrlErrors,
    UpdateUserSchedulingUrlResponses,
    UpdateUserSeniorityData,
    UpdateUserSeniorityErrors,
    UpdateUserSeniorityResponses,
    UpdateUserTargetSalaryData,
    UpdateUserTargetSalaryErrors,
    UpdateUserTargetSalaryResponses,
    UpdateUserWorkInfoData,
    UpdateUserWorkInfoErrors,
    UpdateUserWorkInfoResponses,
    UpdateUserWorkProfileData,
    UpdateUserWorkProfileErrors,
    UpdateUserWorkProfileResponses,
    UploadCustomerHeaderData,
    UploadCustomerHeaderErrors,
    UploadCustomerHeaderResponses,
    UploadCustomerPictureData,
    UploadCustomerPictureErrors,
    UploadCustomerPictureResponses,
    UploadUserDocumentData,
    UploadUserDocumentErrors,
    UploadUserDocumentResponses,
    UploadUserPictureData,
    UploadUserPictureErrors,
    UploadUserPictureResponses,
} from './types.gen';
import {
    zApproveContractBonusPath,
    zApproveContractBonusResponse,
    zApproveContractRaisePath,
    zApproveContractRaiseResponse,
    zApproveOpsApprovalPath,
    zAssignContractingEntityPath,
    zAssignContractingEntityResponse,
    zChangeCountryBody,
    zCheckBankAccountNameBody,
    zCheckBankAccountNameResponse,
    zCheckrWebhookBody,
    zCheckrWebhookHeaders,
    zCheckrWebhookResponse,
    zCompleteCustomerCheckinBody,
    zCompleteCustomerCheckinPath,
    zConfirmEquipmentQuoteShippingInfoBody,
    zConfirmEquipmentQuoteShippingInfoPath,
    zConfirmUserShippingInfoBody,
    zCreateBankAccountBody,
    zCreateBankAccountResponse,
    zCreateContractBonusBody,
    zCreateContractBonusPath,
    zCreateContractBonusResponse,
    zCreateContractingEntityBody,
    zCreateContractingEntityResponse,
    zCreateContractRaiseBody,
    zCreateContractRaisePath,
    zCreateContractRaiseResponse,
    zCreateCustomerGroupBody,
    zCreateCustomerGroupPath,
    zCreateCustomerGroupResponse,
    zCreateCustomerUserBody,
    zCreateCustomerUserPath,
    zCreateCustomerUserResponse,
    zCreateEquipmentBody,
    zCreateEquipmentResponse,
    zDeleteBankAccountPath,
    zDeleteBankAccountResponse,
    zDeleteContractorInvoicePath,
    zDeleteCustomerGroupPath,
    zDeleteCustomerGroupResponse,
    zDeleteCustomerInvoicePath,
    zExpandJobBody,
    zExpandJobPath,
    zExpandJobResponse2,
    zFinishCandidateProfileBuilderBody,
    zFinishCandidateProfileBuilderPath,
    zFinishCandidateProfileBuilderResponse,
    zGetAiInterviewConfigResponse,
    zGetApplicationFitPath,
    zGetApplicationFitResponse,
    zGetBankAccountPath,
    zGetBankAccountResponse,
    zGetCandidateCertificationHistoryPath,
    zGetCandidateCertificationHistoryResponse,
    zGetCandidateExpectedSalaryHistoryPath,
    zGetCandidateExpectedSalaryHistoryResponse,
    zGetCandidateExperimentsHistoryPath,
    zGetCandidateExperimentsHistoryResponse,
    zGetCandidateOpenToOpportunitiesHistoryPath,
    zGetCandidateOpenToOpportunitiesHistoryResponse,
    zGetCandidateProfileBuilderWorkHistoryPath,
    zGetCandidateProfileBuilderWorkHistoryResponse,
    zGetCandidateProfileCompleteHistoryPath,
    zGetCandidateProfileCompleteHistoryResponse,
    zGetCandidateProfileUpdateBookingUrlPath,
    zGetCandidateProfileUpdateBookingUrlResponse,
    zGetCandidateSeniorityHistoryPath,
    zGetCandidateSeniorityHistoryResponse,
    zGetCandidateSourceHistoryPath,
    zGetCandidateSourceHistoryResponse,
    zGetCandidateStatusHistoryPath,
    zGetCandidateStatusHistoryResponse,
    zGetCandidateWorkExperienceHistoryPath,
    zGetCandidateWorkExperienceHistoryResponse,
    zGetContractingEntityPath,
    zGetContractingEntityResponse,
    zGetContractingEntitySelectionPath,
    zGetContractingEntitySelectionResponse,
    zGetContractingEntitySelectionStatusPath,
    zGetContractingEntitySelectionStatusResponse,
    zGetContractorCheckinPath,
    zGetContractorCheckinResponse,
    zGetContractorEmploymentInfoPath,
    zGetContractorEmploymentInfoResponse,
    zGetContractorHealthHistoryPath,
    zGetContractorHealthHistoryResponse,
    zGetContractorHealthPath,
    zGetContractorHealthResponse,
    zGetContractorPersonalInfoPath,
    zGetContractorPersonalInfoResponse,
    zGetContractPath,
    zGetContractResponse,
    zGetCustomerBasicProfilePath,
    zGetCustomerBasicProfileResponse,
    zGetCustomerBillingDataPath,
    zGetCustomerBillingDataResponse,
    zGetCustomerGroupPath,
    zGetCustomerGroupResponse,
    zGetCustomerPoliciesBenefitsPath,
    zGetCustomerPoliciesBenefitsResponse,
    zGetCustomerProfilePath,
    zGetCustomerProfileResponse,
    zGetCustomerStageHistoryPath,
    zGetCustomerStageHistoryResponse,
    zGetCustomerUserResponsibilitiesPath,
    zGetCustomerUserResponsibilitiesResponse,
    zGetEquipmentPath,
    zGetEquipmentQuoteShippingInfoPath,
    zGetEquipmentQuoteShippingInfoResponse,
    zGetEquipmentResponse,
    zGetHealthInsurancePlanPath,
    zGetHealthInsurancePlanResponse,
    zGetJobExpansionPreviewPath,
    zGetJobExpansionPreviewResponse,
    zGetJobOpeningCompanyOwnerHistoryPath,
    zGetJobOpeningCompanyOwnerHistoryResponse,
    zGetJobOpeningHealthHistoryPath,
    zGetJobOpeningHealthHistoryResponse,
    zGetLocationResponse,
    zGetOpsApprovalPath,
    zGetOpsApprovalResponse,
    zGetPaymentAttemptHistoryPath,
    zGetPaymentAttemptHistoryResponse,
    zGetPublicCustomerProfilePath,
    zGetPublicCustomerProfileResponse,
    zGetUserCertificationsPath,
    zGetUserCertificationsResponse,
    zGetUserContactInfoPath,
    zGetUserContactInfoResponse,
    zGetUserJobDetailsResponse,
    zGetUserPendingChangesResponse,
    zGetUserPersonalInfoPath,
    zGetUserPersonalInfoResponse,
    zGetUserProfileResponse,
    zGetUserSchedulingUrlPath,
    zGetUserSchedulingUrlResponse,
    zGetUserSeniorityPath,
    zGetUserSeniorityResponse,
    zGetUserShippingInfoResponse,
    zGetUserWorkInfoPath,
    zGetUserWorkInfoResponse,
    zGetUserWorkProfileResponse,
    zHandleCspReportBody,
    zHandleCspReportHeaders,
    zHandleCspReportResponse,
    zImBulkPreflightBody,
    zImBulkPreflightResponse,
    zImBulkSendBody,
    zImBulkSendResponse,
    zInitAiInterviewBody,
    zInitAiInterviewResponse,
    zListBackgroundCheckPricingResponse,
    zListBackgroundChecksQuery,
    zListBackgroundChecksResponse,
    zListBankAccountsResponse,
    zListContractBonusesPath,
    zListContractBonusesResponse,
    zListContractingEntitiesResponse,
    zListContractRaisesPath,
    zListContractRaisesResponse,
    zListCustomerGroupApproversPath,
    zListCustomerGroupApproversResponse,
    zListCustomerGroupsPath,
    zListCustomerGroupsQuery,
    zListCustomerGroupsResponse,
    zListCustomerInvoicesPath,
    zListCustomerInvoicesQuery,
    zListCustomerInvoicesResponse,
    zListCustomerUsersPath,
    zListCustomerUsersResponse,
    zListOpsApprovalsQuery,
    zListOpsApprovalsResponse2,
    zListUserBankAccountsPath,
    zListUserBankAccountsResponse,
    zListUserContractingEntitiesPath,
    zListUserContractingEntitiesResponse,
    zListUserContractsPath,
    zListUserContractsResponse,
    zListUserDocumentsPath,
    zListUserDocumentsQuery,
    zListUserDocumentsResponse,
    zPayContractorInvoiceBody,
    zPayContractorInvoicePath,
    zReassignCustomerUserResponsibilitiesBody,
    zReassignCustomerUserResponsibilitiesPath,
    zReassignCustomerUserResponsibilitiesResponse,
    zRecordEquipmentQuoteApprovalBody,
    zRecordEquipmentQuoteApprovalPath,
    zRegenerateContractorInvoicePath,
    zRegenerateCustomerInvoicePath,
    zRejectContractBonusPath,
    zRejectContractBonusResponse,
    zRejectContractRaisePath,
    zRejectContractRaiseResponse,
    zRejectOpsApprovalBody,
    zRejectOpsApprovalPath,
    zRequestCandidateProfileUpdateBody,
    zRequestCandidateProfileUpdatePath,
    zRequestCandidateProfileUpdateResponse,
    zRequestContractingEntitySelectionBody,
    zRequestContractingEntitySelectionPath,
    zRequestSalaryChangeResponse,
    zRescoreApplicationPath,
    zRescoreApplicationResponse,
    zRescoreProspectPath,
    zRescoreProspectResponse,
    zReviewApplicationFitBody,
    zReviewApplicationFitPath,
    zReviewApplicationFitResponse,
    zReviewCandidateVerificationBody,
    zReviewCandidateVerificationPath,
    zScheduleContractorCheckinMeetingBody,
    zScheduleContractorCheckinMeetingPath,
    zSearchApplicantsQuery,
    zSearchApplicantsResponse,
    zSearchCandidatesQuery,
    zSearchCandidatesResponse,
    zSearchContractorsQuery,
    zSearchContractorsResponse,
    zSearchCustomerContractorsBody,
    zSearchCustomerContractorsPath,
    zSearchCustomerContractorsResponse,
    zSearchCustomersQuery,
    zSearchCustomersResponse,
    zSelectExistingContractingEntityBody,
    zSelectExistingContractingEntityPath,
    zSelectExistingContractingEntityResponse,
    zSelectNewContractingEntityBody,
    zSelectNewContractingEntityResponse,
    zSetCustomerStatusBody,
    zSetCustomerStatusPath,
    zSetCustomerStatusResponse,
    zSetCustomerUserStatusBody,
    zSetCustomerUserStatusPath,
    zSetCustomerUserStatusResponse,
    zSetCustomerVisibilityBody,
    zSetCustomerVisibilityPath,
    zSetCustomerVisibilityResponse,
    zSetDefaultBankAccountPath,
    zSetDefaultBankAccountResponse,
    zStartCandidateProfileBuilderBody,
    zStartCandidateProfileBuilderPath,
    zStartCandidateProfileBuilderResponse,
    zUndoContractTerminationPath,
    zUndoContractTerminationResponse,
    zUpdateBankAccountBody,
    zUpdateBankAccountPath,
    zUpdateBankAccountResponse,
    zUpdateCandidatePersonalInfoBody,
    zUpdateCandidatePersonalInfoPath,
    zUpdateContractBody,
    zUpdateContractingEntityBody,
    zUpdateContractingEntityPath,
    zUpdateContractingEntityResponse,
    zUpdateContractorEmploymentInfoBody,
    zUpdateContractorEmploymentInfoPath,
    zUpdateContractorHealthBody,
    zUpdateContractorHealthPath,
    zUpdateContractorHealthResponse,
    zUpdateContractorInvoiceAccountBody,
    zUpdateContractorInvoiceAccountPath,
    zUpdateContractorInvoiceStatusBody,
    zUpdateContractorInvoiceStatusPath,
    zUpdateContractPath,
    zUpdateContractResponse,
    zUpdateCustomerBillingAddressBody,
    zUpdateCustomerBillingAddressPath,
    zUpdateCustomerBillingContactsBody,
    zUpdateCustomerBillingContactsPath,
    zUpdateCustomerBillingDetailsBody,
    zUpdateCustomerBillingDetailsPath,
    zUpdateCustomerDetailsBody,
    zUpdateCustomerDetailsPath,
    zUpdateCustomerDetailsResponse,
    zUpdateCustomerGroupBody,
    zUpdateCustomerGroupPath,
    zUpdateCustomerGroupResponse,
    zUpdateCustomerInvoiceStatusBody,
    zUpdateCustomerInvoiceStatusPath,
    zUpdateCustomerPoliciesBenefitsBody,
    zUpdateCustomerPoliciesBenefitsPath,
    zUpdateCustomerPoliciesBenefitsResponse,
    zUpdateCustomerSectionBody,
    zUpdateCustomerSectionPath,
    zUpdateCustomerSectionResponse,
    zUpdateCustomerTalentPreferencesBody,
    zUpdateCustomerTalentPreferencesPath,
    zUpdateCustomerUserBody,
    zUpdateCustomerUserPath,
    zUpdateCustomerUserResponse,
    zUpdateEquipmentBody,
    zUpdateEquipmentPath,
    zUpdateEquipmentResponse,
    zUpdateLocationBody,
    zUpdateProfileBody,
    zUpdateProfilePath,
    zUpdateProfileResponse,
    zUpdateUserCertificationsBody,
    zUpdateUserCertificationsPath,
    zUpdateUserContactInfoBody,
    zUpdateUserContactInfoPath,
    zUpdateUserPersonalInfoBody,
    zUpdateUserPersonalInfoPath,
    zUpdateUserSchedulingUrlBody,
    zUpdateUserSchedulingUrlPath,
    zUpdateUserSeniorityBody,
    zUpdateUserSeniorityPath,
    zUpdateUserTargetSalaryBody,
    zUpdateUserWorkInfoBody,
    zUpdateUserWorkInfoPath,
    zUpdateUserWorkProfileBody,
    zUploadCustomerHeaderBody,
    zUploadCustomerHeaderPath,
    zUploadCustomerHeaderResponse,
    zUploadCustomerPictureBody,
    zUploadCustomerPicturePath,
    zUploadCustomerPictureResponse,
    zUploadUserDocumentBody,
    zUploadUserDocumentResponse,
    zUploadUserPictureBody,
    zUploadUserPictureResponse,
} from './zod.gen';

export type Options<
    TData extends TDataShape = TDataShape,
    ThrowOnError extends boolean = boolean,
    TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Search applicants by name or email
 */
export const searchApplicants = <ThrowOnError extends boolean = false>(
    options: Options<SearchApplicantsData, ThrowOnError>,
): RequestResult<SearchApplicantsResponses, SearchApplicantsErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        SearchApplicantsResponses,
        SearchApplicantsErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: z.never().optional(),
                    query: zSearchApplicantsQuery,
                })
                .parseAsync(data),
        responseValidator: async (data) => await zSearchApplicantsResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/applicants/search',
        ...options,
    });

/**
 * Get the application fit
 */
export const getApplicationFit = <ThrowOnError extends boolean = false>(
    options: Options<GetApplicationFitData, ThrowOnError>,
): RequestResult<GetApplicationFitResponses, GetApplicationFitErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        GetApplicationFitResponses,
        GetApplicationFitErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetApplicationFitPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetApplicationFitResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/applications/{id}/fit',
        ...options,
    });

/**
 * Review the application fit
 */
export const reviewApplicationFit = <ThrowOnError extends boolean = false>(
    options: Options<ReviewApplicationFitData, ThrowOnError>,
): RequestResult<ReviewApplicationFitResponses, ReviewApplicationFitErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<
        ReviewApplicationFitResponses,
        ReviewApplicationFitErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zReviewApplicationFitBody,
                    path: zReviewApplicationFitPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zReviewApplicationFitResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/applications/{id}/fit/review',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Recalculate the candidate score
 */
export const rescoreApplication = <ThrowOnError extends boolean = false>(
    options: Options<RescoreApplicationData, ThrowOnError>,
): RequestResult<RescoreApplicationResponses, RescoreApplicationErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<
        RescoreApplicationResponses,
        RescoreApplicationErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zRescoreApplicationPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zRescoreApplicationResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/applications/{id}/rescore',
        ...options,
    });

/**
 * List background-check orders for the backoffice table
 */
export const listBackgroundChecks = <ThrowOnError extends boolean = false>(
    options?: Options<ListBackgroundChecksData, ThrowOnError>,
): RequestResult<ListBackgroundChecksResponses, ListBackgroundChecksErrors, ThrowOnError, 'data'> =>
    (options?.client ?? client).get<
        ListBackgroundChecksResponses,
        ListBackgroundChecksErrors,
        ThrowOnError,
        'data'
    >({
        querySerializer: { parameters: { status: { array: { explode: false } } } },
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: z.never().optional(),
                    query: zListBackgroundChecksQuery.optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zListBackgroundChecksResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/background-checks',
        ...options,
    });

/**
 * List background-check pricing per country (pre-tax)
 */
export const listBackgroundCheckPricing = <ThrowOnError extends boolean = false>(
    options?: Options<ListBackgroundCheckPricingData, ThrowOnError>,
): RequestResult<
    ListBackgroundCheckPricingResponses,
    ListBackgroundCheckPricingErrors,
    ThrowOnError,
    'data'
> =>
    (options?.client ?? client).get<
        ListBackgroundCheckPricingResponses,
        ListBackgroundCheckPricingErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zListBackgroundCheckPricingResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/background-checks/pricing',
        ...options,
    });

/**
 * Handle Checkr webhook events
 */
export const checkrWebhook = <ThrowOnError extends boolean = false>(
    options: Options<CheckrWebhookData, ThrowOnError>,
): RequestResult<CheckrWebhookResponses, CheckrWebhookErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<
        CheckrWebhookResponses,
        CheckrWebhookErrors,
        ThrowOnError,
        'data'
    >({
        bodySerializer: null,
        requestValidator: async (data) =>
            await z
                .object({
                    body: zCheckrWebhookBody,
                    headers: zCheckrWebhookHeaders.optional(),
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zCheckrWebhookResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/background-checks/webhook',
        ...options,
        headers: {
            'Content-Type': 'application/octet-stream',
            ...options.headers,
        },
    });

/**
 * Get the AI interview configuration
 */
export const getAiInterviewConfig = <ThrowOnError extends boolean = false>(
    options?: Options<GetAiInterviewConfigData, ThrowOnError>,
): RequestResult<GetAiInterviewConfigResponses, GetAiInterviewConfigErrors, ThrowOnError, 'data'> =>
    (options?.client ?? client).get<
        GetAiInterviewConfigResponses,
        GetAiInterviewConfigErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetAiInterviewConfigResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/candidates/ai-interview/config',
        ...options,
    });

/**
 * Bind an AI interview call to the candidate
 */
export const initAiInterview = <ThrowOnError extends boolean = false>(
    options: Options<InitAiInterviewData, ThrowOnError>,
): RequestResult<InitAiInterviewResponses, InitAiInterviewErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<
        InitAiInterviewResponses,
        InitAiInterviewErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zInitAiInterviewBody,
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zInitAiInterviewResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/candidates/ai-interview/init',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Search candidates by name or email
 */
export const searchCandidates = <ThrowOnError extends boolean = false>(
    options: Options<SearchCandidatesData, ThrowOnError>,
): RequestResult<SearchCandidatesResponses, SearchCandidatesErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        SearchCandidatesResponses,
        SearchCandidatesErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: z.never().optional(),
                    query: zSearchCandidatesQuery,
                })
                .parseAsync(data),
        responseValidator: async (data) => await zSearchCandidatesResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/candidates/search',
        ...options,
    });

/**
 * Review a candidate's completed verification
 */
export const reviewCandidateVerification = <ThrowOnError extends boolean = false>(
    options: Options<ReviewCandidateVerificationData, ThrowOnError>,
): RequestResult<
    ReviewCandidateVerificationResponses,
    ReviewCandidateVerificationErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).post<
        ReviewCandidateVerificationResponses,
        ReviewCandidateVerificationErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zReviewCandidateVerificationBody,
                    path: zReviewCandidateVerificationPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/candidates/verifications/{id}/review',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Update a candidate's personal info
 */
export const updateCandidatePersonalInfo = <ThrowOnError extends boolean = false>(
    options: Options<UpdateCandidatePersonalInfoData, ThrowOnError>,
): RequestResult<
    UpdateCandidatePersonalInfoResponses,
    UpdateCandidatePersonalInfoErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).patch<
        UpdateCandidatePersonalInfoResponses,
        UpdateCandidatePersonalInfoErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateCandidatePersonalInfoBody,
                    path: zUpdateCandidatePersonalInfoPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/candidates/{id}/personal-info',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Report a change to a candidate's about or work history
 */
export const requestCandidateProfileUpdate = <ThrowOnError extends boolean = false>(
    options: Options<RequestCandidateProfileUpdateData, ThrowOnError>,
): RequestResult<
    RequestCandidateProfileUpdateResponses,
    RequestCandidateProfileUpdateErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).post<
        RequestCandidateProfileUpdateResponses,
        RequestCandidateProfileUpdateErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zRequestCandidateProfileUpdateBody,
                    path: zRequestCandidateProfileUpdatePath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zRequestCandidateProfileUpdateResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/candidates/{id}/profile-updates',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Get the Calendly URL to book a profile update call
 */
export const getCandidateProfileUpdateBookingUrl = <ThrowOnError extends boolean = false>(
    options: Options<GetCandidateProfileUpdateBookingUrlData, ThrowOnError>,
): RequestResult<
    GetCandidateProfileUpdateBookingUrlResponses,
    GetCandidateProfileUpdateBookingUrlErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetCandidateProfileUpdateBookingUrlResponses,
        GetCandidateProfileUpdateBookingUrlErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetCandidateProfileUpdateBookingUrlPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zGetCandidateProfileUpdateBookingUrlResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/candidates/{id}/profile-updates/booking-url',
        ...options,
    });

/**
 * Finish a candidate's profile builder call
 */
export const finishCandidateProfileBuilder = <ThrowOnError extends boolean = false>(
    options: Options<FinishCandidateProfileBuilderData, ThrowOnError>,
): RequestResult<
    FinishCandidateProfileBuilderResponses,
    FinishCandidateProfileBuilderErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).post<
        FinishCandidateProfileBuilderResponses,
        FinishCandidateProfileBuilderErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zFinishCandidateProfileBuilderBody,
                    path: zFinishCandidateProfileBuilderPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zFinishCandidateProfileBuilderResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/candidates/{id}/profile/builder/finish',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Start a candidate's profile builder call
 */
export const startCandidateProfileBuilder = <ThrowOnError extends boolean = false>(
    options: Options<StartCandidateProfileBuilderData, ThrowOnError>,
): RequestResult<
    StartCandidateProfileBuilderResponses,
    StartCandidateProfileBuilderErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).post<
        StartCandidateProfileBuilderResponses,
        StartCandidateProfileBuilderErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zStartCandidateProfileBuilderBody,
                    path: zStartCandidateProfileBuilderPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zStartCandidateProfileBuilderResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/candidates/{id}/profile/builder/init',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Get a candidate's profile builder work history
 */
export const getCandidateProfileBuilderWorkHistory = <ThrowOnError extends boolean = false>(
    options: Options<GetCandidateProfileBuilderWorkHistoryData, ThrowOnError>,
): RequestResult<
    GetCandidateProfileBuilderWorkHistoryResponses,
    GetCandidateProfileBuilderWorkHistoryErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetCandidateProfileBuilderWorkHistoryResponses,
        GetCandidateProfileBuilderWorkHistoryErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetCandidateProfileBuilderWorkHistoryPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zGetCandidateProfileBuilderWorkHistoryResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/candidates/{id}/profile/builder/work-history',
        ...options,
    });

/**
 * Get a contractor check-in for the entry screen
 */
export const getContractorCheckin = <ThrowOnError extends boolean = false>(
    options: Options<GetContractorCheckinData, ThrowOnError>,
): RequestResult<GetContractorCheckinResponses, GetContractorCheckinErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        GetContractorCheckinResponses,
        GetContractorCheckinErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetContractorCheckinPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetContractorCheckinResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/checkins/contractors/{id}',
        ...options,
    });

/**
 * Record a booked meeting for a contractor check-in
 */
export const scheduleContractorCheckinMeeting = <ThrowOnError extends boolean = false>(
    options: Options<ScheduleContractorCheckinMeetingData, ThrowOnError>,
): RequestResult<
    ScheduleContractorCheckinMeetingResponses,
    ScheduleContractorCheckinMeetingErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).post<
        ScheduleContractorCheckinMeetingResponses,
        ScheduleContractorCheckinMeetingErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zScheduleContractorCheckinMeetingBody,
                    path: zScheduleContractorCheckinMeetingPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/checkins/contractors/{id}/schedule-meeting',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Complete a customer check-in on behalf of the customer
 */
export const completeCustomerCheckin = <ThrowOnError extends boolean = false>(
    options: Options<CompleteCustomerCheckinData, ThrowOnError>,
): RequestResult<
    CompleteCustomerCheckinResponses,
    CompleteCustomerCheckinErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).post<
        CompleteCustomerCheckinResponses,
        CompleteCustomerCheckinErrors,
        ThrowOnError,
        'data'
    >({
        ...formDataBodySerializer,
        requestValidator: async (data) =>
            await z
                .object({
                    body: zCompleteCustomerCheckinBody.optional(),
                    path: zCompleteCustomerCheckinPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/checkins/customers/{id}/complete',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers,
        },
    });

/**
 * Get a public customer profile by permalink
 */
export const getPublicCustomerProfile = <ThrowOnError extends boolean = false>(
    options: Options<GetPublicCustomerProfileData, ThrowOnError>,
): RequestResult<
    GetPublicCustomerProfileResponses,
    GetPublicCustomerProfileErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetPublicCustomerProfileResponses,
        GetPublicCustomerProfileErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetPublicCustomerProfilePath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetPublicCustomerProfileResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/companies/{permalink}',
        ...options,
    });

/**
 * Delete a contractor invoice
 */
export const deleteContractorInvoice = <ThrowOnError extends boolean = false>(
    options: Options<DeleteContractorInvoiceData, ThrowOnError>,
): RequestResult<
    DeleteContractorInvoiceResponses,
    DeleteContractorInvoiceErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).delete<
        DeleteContractorInvoiceResponses,
        DeleteContractorInvoiceErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zDeleteContractorInvoicePath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/contractors/invoices/{id}',
        ...options,
    });

/**
 * Pay a contractor invoice through Nium
 */
export const payContractorInvoice = <ThrowOnError extends boolean = false>(
    options: Options<PayContractorInvoiceData, ThrowOnError>,
): RequestResult<PayContractorInvoiceResponses, PayContractorInvoiceErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<
        PayContractorInvoiceResponses,
        PayContractorInvoiceErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zPayContractorInvoiceBody,
                    path: zPayContractorInvoicePath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/contractors/invoices/{id}/pay',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Regenerate a contractor invoice
 */
export const regenerateContractorInvoice = <ThrowOnError extends boolean = false>(
    options: Options<RegenerateContractorInvoiceData, ThrowOnError>,
): RequestResult<
    RegenerateContractorInvoiceResponses,
    RegenerateContractorInvoiceErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).post<
        RegenerateContractorInvoiceResponses,
        RegenerateContractorInvoiceErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zRegenerateContractorInvoicePath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/contractors/invoices/{id}/regenerate',
        ...options,
    });

/**
 * Update the status of a contractor invoice
 */
export const updateContractorInvoiceStatus = <ThrowOnError extends boolean = false>(
    options: Options<UpdateContractorInvoiceStatusData, ThrowOnError>,
): RequestResult<
    UpdateContractorInvoiceStatusResponses,
    UpdateContractorInvoiceStatusErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).patch<
        UpdateContractorInvoiceStatusResponses,
        UpdateContractorInvoiceStatusErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateContractorInvoiceStatusBody,
                    path: zUpdateContractorInvoiceStatusPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/contractors/invoices/{id}/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Update the bank account of a contractor invoice that is not paid
 */
export const updateContractorInvoiceAccount = <ThrowOnError extends boolean = false>(
    options: Options<UpdateContractorInvoiceAccountData, ThrowOnError>,
): RequestResult<
    UpdateContractorInvoiceAccountResponses,
    UpdateContractorInvoiceAccountErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).post<
        UpdateContractorInvoiceAccountResponses,
        UpdateContractorInvoiceAccountErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateContractorInvoiceAccountBody,
                    path: zUpdateContractorInvoiceAccountPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/contractors/invoices/{id}/update-account',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Search contractors by name or email
 */
export const searchContractors = <ThrowOnError extends boolean = false>(
    options: Options<SearchContractorsData, ThrowOnError>,
): RequestResult<SearchContractorsResponses, SearchContractorsErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        SearchContractorsResponses,
        SearchContractorsErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: z.never().optional(),
                    query: zSearchContractorsQuery,
                })
                .parseAsync(data),
        responseValidator: async (data) => await zSearchContractorsResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/contractors/search',
        ...options,
    });

/**
 * Get a contract
 */
export const getContract = <ThrowOnError extends boolean = false>(
    options: Options<GetContractData, ThrowOnError>,
): RequestResult<GetContractResponses, GetContractErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<GetContractResponses, GetContractErrors, ThrowOnError, 'data'>({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetContractPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetContractResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/contracts/{id}',
        ...options,
    });

/**
 * Update a contract
 */
export const updateContract = <ThrowOnError extends boolean = false>(
    options: Options<UpdateContractData, ThrowOnError>,
): RequestResult<UpdateContractResponses, UpdateContractErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).patch<
        UpdateContractResponses,
        UpdateContractErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateContractBody,
                    path: zUpdateContractPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zUpdateContractResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/contracts/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * List a contract's bonuses
 */
export const listContractBonuses = <ThrowOnError extends boolean = false>(
    options: Options<ListContractBonusesData, ThrowOnError>,
): RequestResult<ListContractBonusesResponses, ListContractBonusesErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        ListContractBonusesResponses,
        ListContractBonusesErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zListContractBonusesPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zListContractBonusesResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/contracts/{id}/bonuses',
        ...options,
    });

/**
 * Give a bonus to a contractor
 */
export const createContractBonus = <ThrowOnError extends boolean = false>(
    options: Options<CreateContractBonusData, ThrowOnError>,
): RequestResult<CreateContractBonusResponses, CreateContractBonusErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<
        CreateContractBonusResponses,
        CreateContractBonusErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zCreateContractBonusBody,
                    path: zCreateContractBonusPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zCreateContractBonusResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/contracts/{id}/bonuses',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Approve a pending bonus
 */
export const approveContractBonus = <ThrowOnError extends boolean = false>(
    options: Options<ApproveContractBonusData, ThrowOnError>,
): RequestResult<ApproveContractBonusResponses, ApproveContractBonusErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<
        ApproveContractBonusResponses,
        ApproveContractBonusErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zApproveContractBonusPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zApproveContractBonusResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/contracts/{id}/bonuses/{bonus_id}/approve',
        ...options,
    });

/**
 * Reject a pending bonus
 */
export const rejectContractBonus = <ThrowOnError extends boolean = false>(
    options: Options<RejectContractBonusData, ThrowOnError>,
): RequestResult<RejectContractBonusResponses, RejectContractBonusErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<
        RejectContractBonusResponses,
        RejectContractBonusErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zRejectContractBonusPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zRejectContractBonusResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/contracts/{id}/bonuses/{bonus_id}/reject',
        ...options,
    });

/**
 * Get a contract's customer health status and history
 */
export const getContractorHealth = <ThrowOnError extends boolean = false>(
    options: Options<GetContractorHealthData, ThrowOnError>,
): RequestResult<GetContractorHealthResponses, GetContractorHealthErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        GetContractorHealthResponses,
        GetContractorHealthErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetContractorHealthPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetContractorHealthResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/contracts/{id}/health',
        ...options,
    });

/**
 * Set or update a contract's customer health status
 */
export const updateContractorHealth = <ThrowOnError extends boolean = false>(
    options: Options<UpdateContractorHealthData, ThrowOnError>,
): RequestResult<
    UpdateContractorHealthResponses,
    UpdateContractorHealthErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).put<
        UpdateContractorHealthResponses,
        UpdateContractorHealthErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateContractorHealthBody,
                    path: zUpdateContractorHealthPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zUpdateContractorHealthResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/contracts/{id}/health',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * List a contract's fee history
 */
export const listContractRaises = <ThrowOnError extends boolean = false>(
    options: Options<ListContractRaisesData, ThrowOnError>,
): RequestResult<ListContractRaisesResponses, ListContractRaisesErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        ListContractRaisesResponses,
        ListContractRaisesErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zListContractRaisesPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zListContractRaisesResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/contracts/{id}/raises',
        ...options,
    });

/**
 * Submit a fee change for a contract
 */
export const createContractRaise = <ThrowOnError extends boolean = false>(
    options: Options<CreateContractRaiseData, ThrowOnError>,
): RequestResult<CreateContractRaiseResponses, CreateContractRaiseErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<
        CreateContractRaiseResponses,
        CreateContractRaiseErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zCreateContractRaiseBody,
                    path: zCreateContractRaisePath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zCreateContractRaiseResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/contracts/{id}/raises',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Approve a pending fee change
 */
export const approveContractRaise = <ThrowOnError extends boolean = false>(
    options: Options<ApproveContractRaiseData, ThrowOnError>,
): RequestResult<ApproveContractRaiseResponses, ApproveContractRaiseErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<
        ApproveContractRaiseResponses,
        ApproveContractRaiseErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zApproveContractRaisePath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zApproveContractRaiseResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/contracts/{id}/raises/{raise_id}/approve',
        ...options,
    });

/**
 * Reject a pending fee change
 */
export const rejectContractRaise = <ThrowOnError extends boolean = false>(
    options: Options<RejectContractRaiseData, ThrowOnError>,
): RequestResult<RejectContractRaiseResponses, RejectContractRaiseErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<
        RejectContractRaiseResponses,
        RejectContractRaiseErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zRejectContractRaisePath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zRejectContractRaiseResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/contracts/{id}/raises/{raise_id}/reject',
        ...options,
    });

/**
 * Undo a contract termination
 */
export const undoContractTermination = <ThrowOnError extends boolean = false>(
    options: Options<UndoContractTerminationData, ThrowOnError>,
): RequestResult<
    UndoContractTerminationResponses,
    UndoContractTerminationErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).post<
        UndoContractTerminationResponses,
        UndoContractTerminationErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zUndoContractTerminationPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zUndoContractTerminationResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/contracts/{id}/undo-termination',
        ...options,
    });

/**
 * Handle a Content-Security-Policy violation report
 */
export const handleCspReport = <ThrowOnError extends boolean = false>(
    options: Options<HandleCspReportData, ThrowOnError>,
): RequestResult<HandleCspReportResponses, HandleCspReportErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<
        HandleCspReportResponses,
        HandleCspReportErrors,
        ThrowOnError,
        'data'
    >({
        bodySerializer: null,
        requestValidator: async (data) =>
            await z
                .object({
                    body: zHandleCspReportBody,
                    headers: zHandleCspReportHeaders.optional(),
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zHandleCspReportResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/csp-report',
        ...options,
        headers: {
            'Content-Type': 'application/octet-stream',
            ...options.headers,
        },
    });

/**
 * Delete a customer invoice
 */
export const deleteCustomerInvoice = <ThrowOnError extends boolean = false>(
    options: Options<DeleteCustomerInvoiceData, ThrowOnError>,
): RequestResult<
    DeleteCustomerInvoiceResponses,
    DeleteCustomerInvoiceErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).delete<
        DeleteCustomerInvoiceResponses,
        DeleteCustomerInvoiceErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zDeleteCustomerInvoicePath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/customers/invoices/{id}',
        ...options,
    });

/**
 * Regenerate a customer invoice
 */
export const regenerateCustomerInvoice = <ThrowOnError extends boolean = false>(
    options: Options<RegenerateCustomerInvoiceData, ThrowOnError>,
): RequestResult<
    RegenerateCustomerInvoiceResponses,
    RegenerateCustomerInvoiceErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).post<
        RegenerateCustomerInvoiceResponses,
        RegenerateCustomerInvoiceErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zRegenerateCustomerInvoicePath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/customers/invoices/{id}/regenerate',
        ...options,
    });

/**
 * Update the status of a customer invoice
 */
export const updateCustomerInvoiceStatus = <ThrowOnError extends boolean = false>(
    options: Options<UpdateCustomerInvoiceStatusData, ThrowOnError>,
): RequestResult<
    UpdateCustomerInvoiceStatusResponses,
    UpdateCustomerInvoiceStatusErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).post<
        UpdateCustomerInvoiceStatusResponses,
        UpdateCustomerInvoiceStatusErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateCustomerInvoiceStatusBody,
                    path: zUpdateCustomerInvoiceStatusPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/customers/invoices/{id}/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Search customers by company name
 */
export const searchCustomers = <ThrowOnError extends boolean = false>(
    options: Options<SearchCustomersData, ThrowOnError>,
): RequestResult<SearchCustomersResponses, SearchCustomersErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        SearchCustomersResponses,
        SearchCustomersErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: z.never().optional(),
                    query: zSearchCustomersQuery,
                })
                .parseAsync(data),
        responseValidator: async (data) => await zSearchCustomersResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/search',
        ...options,
    });

/**
 * Get a customer's billing data
 */
export const getCustomerBillingData = <ThrowOnError extends boolean = false>(
    options: Options<GetCustomerBillingDataData, ThrowOnError>,
): RequestResult<
    GetCustomerBillingDataResponses,
    GetCustomerBillingDataErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetCustomerBillingDataResponses,
        GetCustomerBillingDataErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetCustomerBillingDataPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetCustomerBillingDataResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/billing',
        ...options,
    });

/**
 * Update a customer's billing address
 */
export const updateCustomerBillingAddress = <ThrowOnError extends boolean = false>(
    options: Options<UpdateCustomerBillingAddressData, ThrowOnError>,
): RequestResult<
    UpdateCustomerBillingAddressResponses,
    UpdateCustomerBillingAddressErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).patch<
        UpdateCustomerBillingAddressResponses,
        UpdateCustomerBillingAddressErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateCustomerBillingAddressBody,
                    path: zUpdateCustomerBillingAddressPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/billing/address',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Update a customer's billing contacts
 */
export const updateCustomerBillingContacts = <ThrowOnError extends boolean = false>(
    options: Options<UpdateCustomerBillingContactsData, ThrowOnError>,
): RequestResult<
    UpdateCustomerBillingContactsResponses,
    UpdateCustomerBillingContactsErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).patch<
        UpdateCustomerBillingContactsResponses,
        UpdateCustomerBillingContactsErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateCustomerBillingContactsBody,
                    path: zUpdateCustomerBillingContactsPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/billing/contacts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Update a customer's billing details
 */
export const updateCustomerBillingDetails = <ThrowOnError extends boolean = false>(
    options: Options<UpdateCustomerBillingDetailsData, ThrowOnError>,
): RequestResult<
    UpdateCustomerBillingDetailsResponses,
    UpdateCustomerBillingDetailsErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).patch<
        UpdateCustomerBillingDetailsResponses,
        UpdateCustomerBillingDetailsErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateCustomerBillingDetailsBody,
                    path: zUpdateCustomerBillingDetailsPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/billing/details',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Search contractors for the customer
 */
export const searchCustomerContractors = <ThrowOnError extends boolean = false>(
    options: Options<SearchCustomerContractorsData, ThrowOnError>,
): RequestResult<
    SearchCustomerContractorsResponses,
    SearchCustomerContractorsErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).post<
        SearchCustomerContractorsResponses,
        SearchCustomerContractorsErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zSearchCustomerContractorsBody,
                    path: zSearchCustomerContractorsPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zSearchCustomerContractorsResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/contractors/search',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Get a contractor's employment info
 */
export const getContractorEmploymentInfo = <ThrowOnError extends boolean = false>(
    options: Options<GetContractorEmploymentInfoData, ThrowOnError>,
): RequestResult<
    GetContractorEmploymentInfoResponses,
    GetContractorEmploymentInfoErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetContractorEmploymentInfoResponses,
        GetContractorEmploymentInfoErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetContractorEmploymentInfoPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zGetContractorEmploymentInfoResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/contractors/{contractor_id}/employment-info',
        ...options,
    });

/**
 * Update a contractor's managers and group
 */
export const updateContractorEmploymentInfo = <ThrowOnError extends boolean = false>(
    options: Options<UpdateContractorEmploymentInfoData, ThrowOnError>,
): RequestResult<
    UpdateContractorEmploymentInfoResponses,
    UpdateContractorEmploymentInfoErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).patch<
        UpdateContractorEmploymentInfoResponses,
        UpdateContractorEmploymentInfoErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateContractorEmploymentInfoBody,
                    path: zUpdateContractorEmploymentInfoPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/contractors/{contractor_id}/employment-info',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Get a contractor's personal info
 */
export const getContractorPersonalInfo = <ThrowOnError extends boolean = false>(
    options: Options<GetContractorPersonalInfoData, ThrowOnError>,
): RequestResult<
    GetContractorPersonalInfoResponses,
    GetContractorPersonalInfoErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetContractorPersonalInfoResponses,
        GetContractorPersonalInfoErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetContractorPersonalInfoPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zGetContractorPersonalInfoResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/contractors/{contractor_id}/personal-info',
        ...options,
    });

/**
 * List customer groups
 */
export const listCustomerGroups = <ThrowOnError extends boolean = false>(
    options: Options<ListCustomerGroupsData, ThrowOnError>,
): RequestResult<ListCustomerGroupsResponses, ListCustomerGroupsErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        ListCustomerGroupsResponses,
        ListCustomerGroupsErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zListCustomerGroupsPath,
                    query: zListCustomerGroupsQuery.optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zListCustomerGroupsResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/groups',
        ...options,
    });

/**
 * Create a customer group
 */
export const createCustomerGroup = <ThrowOnError extends boolean = false>(
    options: Options<CreateCustomerGroupData, ThrowOnError>,
): RequestResult<CreateCustomerGroupResponses, CreateCustomerGroupErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<
        CreateCustomerGroupResponses,
        CreateCustomerGroupErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zCreateCustomerGroupBody,
                    path: zCreateCustomerGroupPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zCreateCustomerGroupResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/groups',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * List users eligible to approve at the group level
 */
export const listCustomerGroupApprovers = <ThrowOnError extends boolean = false>(
    options: Options<ListCustomerGroupApproversData, ThrowOnError>,
): RequestResult<
    ListCustomerGroupApproversResponses,
    ListCustomerGroupApproversErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        ListCustomerGroupApproversResponses,
        ListCustomerGroupApproversErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zListCustomerGroupApproversPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zListCustomerGroupApproversResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/groups/approvers',
        ...options,
    });

/**
 * Delete a customer group
 */
export const deleteCustomerGroup = <ThrowOnError extends boolean = false>(
    options: Options<DeleteCustomerGroupData, ThrowOnError>,
): RequestResult<DeleteCustomerGroupResponses, DeleteCustomerGroupErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).delete<
        DeleteCustomerGroupResponses,
        DeleteCustomerGroupErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zDeleteCustomerGroupPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zDeleteCustomerGroupResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/groups/{group_id}',
        ...options,
    });

/**
 * Get a single customer group
 */
export const getCustomerGroup = <ThrowOnError extends boolean = false>(
    options: Options<GetCustomerGroupData, ThrowOnError>,
): RequestResult<GetCustomerGroupResponses, GetCustomerGroupErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        GetCustomerGroupResponses,
        GetCustomerGroupErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetCustomerGroupPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetCustomerGroupResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/groups/{group_id}',
        ...options,
    });

/**
 * Update a customer group
 */
export const updateCustomerGroup = <ThrowOnError extends boolean = false>(
    options: Options<UpdateCustomerGroupData, ThrowOnError>,
): RequestResult<UpdateCustomerGroupResponses, UpdateCustomerGroupErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).patch<
        UpdateCustomerGroupResponses,
        UpdateCustomerGroupErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateCustomerGroupBody,
                    path: zUpdateCustomerGroupPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zUpdateCustomerGroupResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/groups/{group_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * List customer invoices
 */
export const listCustomerInvoices = <ThrowOnError extends boolean = false>(
    options: Options<ListCustomerInvoicesData, ThrowOnError>,
): RequestResult<ListCustomerInvoicesResponses, ListCustomerInvoicesErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        ListCustomerInvoicesResponses,
        ListCustomerInvoicesErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zListCustomerInvoicesPath,
                    query: zListCustomerInvoicesQuery.optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zListCustomerInvoicesResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/invoices',
        ...options,
    });

/**
 * Get a customer's policies and benefits
 */
export const getCustomerPoliciesBenefits = <ThrowOnError extends boolean = false>(
    options: Options<GetCustomerPoliciesBenefitsData, ThrowOnError>,
): RequestResult<
    GetCustomerPoliciesBenefitsResponses,
    GetCustomerPoliciesBenefitsErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetCustomerPoliciesBenefitsResponses,
        GetCustomerPoliciesBenefitsErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetCustomerPoliciesBenefitsPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zGetCustomerPoliciesBenefitsResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/policies-benefits',
        ...options,
    });

/**
 * Update a customer's policies and benefits
 */
export const updateCustomerPoliciesBenefits = <ThrowOnError extends boolean = false>(
    options: Options<UpdateCustomerPoliciesBenefitsData, ThrowOnError>,
): RequestResult<
    UpdateCustomerPoliciesBenefitsResponses,
    UpdateCustomerPoliciesBenefitsErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).patch<
        UpdateCustomerPoliciesBenefitsResponses,
        UpdateCustomerPoliciesBenefitsErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateCustomerPoliciesBenefitsBody,
                    path: zUpdateCustomerPoliciesBenefitsPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zUpdateCustomerPoliciesBenefitsResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/policies-benefits',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Get a customer's profile
 */
export const getCustomerProfile = <ThrowOnError extends boolean = false>(
    options: Options<GetCustomerProfileData, ThrowOnError>,
): RequestResult<GetCustomerProfileResponses, GetCustomerProfileErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        GetCustomerProfileResponses,
        GetCustomerProfileErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetCustomerProfilePath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetCustomerProfileResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/profile',
        ...options,
    });

/**
 * Update customer profile
 */
export const updateProfile = <ThrowOnError extends boolean = false>(
    options: Options<UpdateProfileData, ThrowOnError>,
): RequestResult<UpdateProfileResponses, UpdateProfileErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).patch<
        UpdateProfileResponses,
        UpdateProfileErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateProfileBody,
                    path: zUpdateProfilePath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zUpdateProfileResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/profile',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Get a customer's basic profile (name, logo, header)
 */
export const getCustomerBasicProfile = <ThrowOnError extends boolean = false>(
    options: Options<GetCustomerBasicProfileData, ThrowOnError>,
): RequestResult<
    GetCustomerBasicProfileResponses,
    GetCustomerBasicProfileErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetCustomerBasicProfileResponses,
        GetCustomerBasicProfileErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetCustomerBasicProfilePath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetCustomerBasicProfileResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/profile/basic',
        ...options,
    });

/**
 * Update customer details
 */
export const updateCustomerDetails = <ThrowOnError extends boolean = false>(
    options: Options<UpdateCustomerDetailsData, ThrowOnError>,
): RequestResult<
    UpdateCustomerDetailsResponses,
    UpdateCustomerDetailsErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).patch<
        UpdateCustomerDetailsResponses,
        UpdateCustomerDetailsErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateCustomerDetailsBody,
                    path: zUpdateCustomerDetailsPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zUpdateCustomerDetailsResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/profile/details',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Upload a new header image for the customer
 */
export const uploadCustomerHeader = <ThrowOnError extends boolean = false>(
    options: Options<UploadCustomerHeaderData, ThrowOnError>,
): RequestResult<UploadCustomerHeaderResponses, UploadCustomerHeaderErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<
        UploadCustomerHeaderResponses,
        UploadCustomerHeaderErrors,
        ThrowOnError,
        'data'
    >({
        ...formDataBodySerializer,
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUploadCustomerHeaderBody.optional(),
                    path: zUploadCustomerHeaderPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zUploadCustomerHeaderResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/profile/header',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers,
        },
    });

/**
 * Upload a new logo for the customer
 */
export const uploadCustomerPicture = <ThrowOnError extends boolean = false>(
    options: Options<UploadCustomerPictureData, ThrowOnError>,
): RequestResult<
    UploadCustomerPictureResponses,
    UploadCustomerPictureErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).post<
        UploadCustomerPictureResponses,
        UploadCustomerPictureErrors,
        ThrowOnError,
        'data'
    >({
        ...formDataBodySerializer,
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUploadCustomerPictureBody.optional(),
                    path: zUploadCustomerPicturePath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zUploadCustomerPictureResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/profile/picture',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers,
        },
    });

/**
 * Update a customer description section
 */
export const updateCustomerSection = <ThrowOnError extends boolean = false>(
    options: Options<UpdateCustomerSectionData, ThrowOnError>,
): RequestResult<
    UpdateCustomerSectionResponses,
    UpdateCustomerSectionErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).patch<
        UpdateCustomerSectionResponses,
        UpdateCustomerSectionErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateCustomerSectionBody,
                    path: zUpdateCustomerSectionPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zUpdateCustomerSectionResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/profile/section',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Set or recompute the customer's status
 */
export const setCustomerStatus = <ThrowOnError extends boolean = false>(
    options: Options<SetCustomerStatusData, ThrowOnError>,
): RequestResult<SetCustomerStatusResponses, SetCustomerStatusErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).patch<
        SetCustomerStatusResponses,
        SetCustomerStatusErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zSetCustomerStatusBody,
                    path: zSetCustomerStatusPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zSetCustomerStatusResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Update a customer's talent preferences
 */
export const updateCustomerTalentPreferences = <ThrowOnError extends boolean = false>(
    options: Options<UpdateCustomerTalentPreferencesData, ThrowOnError>,
): RequestResult<
    UpdateCustomerTalentPreferencesResponses,
    UpdateCustomerTalentPreferencesErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).patch<
        UpdateCustomerTalentPreferencesResponses,
        UpdateCustomerTalentPreferencesErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateCustomerTalentPreferencesBody,
                    path: zUpdateCustomerTalentPreferencesPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/talent-preferences',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * List users for the customer
 */
export const listCustomerUsers = <ThrowOnError extends boolean = false>(
    options: Options<ListCustomerUsersData, ThrowOnError>,
): RequestResult<ListCustomerUsersResponses, ListCustomerUsersErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        ListCustomerUsersResponses,
        ListCustomerUsersErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zListCustomerUsersPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zListCustomerUsersResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/users',
        ...options,
    });

/**
 * Create a customer user
 */
export const createCustomerUser = <ThrowOnError extends boolean = false>(
    options: Options<CreateCustomerUserData, ThrowOnError>,
): RequestResult<CreateCustomerUserResponses, CreateCustomerUserErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<
        CreateCustomerUserResponses,
        CreateCustomerUserErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zCreateCustomerUserBody,
                    path: zCreateCustomerUserPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zCreateCustomerUserResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/users',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Update a customer user
 */
export const updateCustomerUser = <ThrowOnError extends boolean = false>(
    options: Options<UpdateCustomerUserData, ThrowOnError>,
): RequestResult<UpdateCustomerUserResponses, UpdateCustomerUserErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).patch<
        UpdateCustomerUserResponses,
        UpdateCustomerUserErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateCustomerUserBody,
                    path: zUpdateCustomerUserPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zUpdateCustomerUserResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/users/{user_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Reassign a user's responsibilities to other users
 */
export const reassignCustomerUserResponsibilities = <ThrowOnError extends boolean = false>(
    options: Options<ReassignCustomerUserResponsibilitiesData, ThrowOnError>,
): RequestResult<
    ReassignCustomerUserResponsibilitiesResponses,
    ReassignCustomerUserResponsibilitiesErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).post<
        ReassignCustomerUserResponsibilitiesResponses,
        ReassignCustomerUserResponsibilitiesErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zReassignCustomerUserResponsibilitiesBody,
                    path: zReassignCustomerUserResponsibilitiesPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zReassignCustomerUserResponsibilitiesResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/users/{user_id}/reassign',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Get a user's active responsibilities
 */
export const getCustomerUserResponsibilities = <ThrowOnError extends boolean = false>(
    options: Options<GetCustomerUserResponsibilitiesData, ThrowOnError>,
): RequestResult<
    GetCustomerUserResponsibilitiesResponses,
    GetCustomerUserResponsibilitiesErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetCustomerUserResponsibilitiesResponses,
        GetCustomerUserResponsibilitiesErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetCustomerUserResponsibilitiesPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zGetCustomerUserResponsibilitiesResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/users/{user_id}/responsibilities',
        ...options,
    });

/**
 * Set a customer user's active/inactive status
 */
export const setCustomerUserStatus = <ThrowOnError extends boolean = false>(
    options: Options<SetCustomerUserStatusData, ThrowOnError>,
): RequestResult<
    SetCustomerUserStatusResponses,
    SetCustomerUserStatusErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).post<
        SetCustomerUserStatusResponses,
        SetCustomerUserStatusErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zSetCustomerUserStatusBody,
                    path: zSetCustomerUserStatusPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zSetCustomerUserStatusResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/users/{user_id}/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Set whether the customer is publicly visible
 */
export const setCustomerVisibility = <ThrowOnError extends boolean = false>(
    options: Options<SetCustomerVisibilityData, ThrowOnError>,
): RequestResult<
    SetCustomerVisibilityResponses,
    SetCustomerVisibilityErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).patch<
        SetCustomerVisibilityResponses,
        SetCustomerVisibilityErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zSetCustomerVisibilityBody,
                    path: zSetCustomerVisibilityPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zSetCustomerVisibilityResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/customers/{id}/visibility',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Get certification change history for a candidate
 */
export const getCandidateCertificationHistory = <ThrowOnError extends boolean = false>(
    options: Options<GetCandidateCertificationHistoryData, ThrowOnError>,
): RequestResult<
    GetCandidateCertificationHistoryResponses,
    GetCandidateCertificationHistoryErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetCandidateCertificationHistoryResponses,
        GetCandidateCertificationHistoryErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetCandidateCertificationHistoryPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zGetCandidateCertificationHistoryResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/entity-history/candidate-certification/{id}',
        ...options,
    });

/**
 * Get expected salary history for a candidate
 */
export const getCandidateExpectedSalaryHistory = <ThrowOnError extends boolean = false>(
    options: Options<GetCandidateExpectedSalaryHistoryData, ThrowOnError>,
): RequestResult<
    GetCandidateExpectedSalaryHistoryResponses,
    GetCandidateExpectedSalaryHistoryErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetCandidateExpectedSalaryHistoryResponses,
        GetCandidateExpectedSalaryHistoryErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetCandidateExpectedSalaryHistoryPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zGetCandidateExpectedSalaryHistoryResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/entity-history/candidate-expected-salary/{id}',
        ...options,
    });

/**
 * Get experiments change history for a candidate
 */
export const getCandidateExperimentsHistory = <ThrowOnError extends boolean = false>(
    options: Options<GetCandidateExperimentsHistoryData, ThrowOnError>,
): RequestResult<
    GetCandidateExperimentsHistoryResponses,
    GetCandidateExperimentsHistoryErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetCandidateExperimentsHistoryResponses,
        GetCandidateExperimentsHistoryErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetCandidateExperimentsHistoryPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zGetCandidateExperimentsHistoryResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/entity-history/candidate-experiments/{id}',
        ...options,
    });

/**
 * Get open-to-opportunities change history for a candidate
 */
export const getCandidateOpenToOpportunitiesHistory = <ThrowOnError extends boolean = false>(
    options: Options<GetCandidateOpenToOpportunitiesHistoryData, ThrowOnError>,
): RequestResult<
    GetCandidateOpenToOpportunitiesHistoryResponses,
    GetCandidateOpenToOpportunitiesHistoryErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetCandidateOpenToOpportunitiesHistoryResponses,
        GetCandidateOpenToOpportunitiesHistoryErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetCandidateOpenToOpportunitiesHistoryPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zGetCandidateOpenToOpportunitiesHistoryResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/entity-history/candidate-open-to-opportunities/{id}',
        ...options,
    });

/**
 * Get profile complete change history for a candidate
 */
export const getCandidateProfileCompleteHistory = <ThrowOnError extends boolean = false>(
    options: Options<GetCandidateProfileCompleteHistoryData, ThrowOnError>,
): RequestResult<
    GetCandidateProfileCompleteHistoryResponses,
    GetCandidateProfileCompleteHistoryErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetCandidateProfileCompleteHistoryResponses,
        GetCandidateProfileCompleteHistoryErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetCandidateProfileCompleteHistoryPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zGetCandidateProfileCompleteHistoryResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/entity-history/candidate-profile-complete/{id}',
        ...options,
    });

/**
 * Get IC level change history for a candidate
 */
export const getCandidateSeniorityHistory = <ThrowOnError extends boolean = false>(
    options: Options<GetCandidateSeniorityHistoryData, ThrowOnError>,
): RequestResult<
    GetCandidateSeniorityHistoryResponses,
    GetCandidateSeniorityHistoryErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetCandidateSeniorityHistoryResponses,
        GetCandidateSeniorityHistoryErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetCandidateSeniorityHistoryPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zGetCandidateSeniorityHistoryResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/entity-history/candidate-seniority/{id}',
        ...options,
    });

/**
 * Get source change history for a candidate
 */
export const getCandidateSourceHistory = <ThrowOnError extends boolean = false>(
    options: Options<GetCandidateSourceHistoryData, ThrowOnError>,
): RequestResult<
    GetCandidateSourceHistoryResponses,
    GetCandidateSourceHistoryErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetCandidateSourceHistoryResponses,
        GetCandidateSourceHistoryErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetCandidateSourceHistoryPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zGetCandidateSourceHistoryResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/entity-history/candidate-source/{id}',
        ...options,
    });

/**
 * Get status change history for a candidate
 */
export const getCandidateStatusHistory = <ThrowOnError extends boolean = false>(
    options: Options<GetCandidateStatusHistoryData, ThrowOnError>,
): RequestResult<
    GetCandidateStatusHistoryResponses,
    GetCandidateStatusHistoryErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetCandidateStatusHistoryResponses,
        GetCandidateStatusHistoryErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetCandidateStatusHistoryPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zGetCandidateStatusHistoryResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/entity-history/candidate-status/{id}',
        ...options,
    });

/**
 * Get work experience change history for a candidate
 */
export const getCandidateWorkExperienceHistory = <ThrowOnError extends boolean = false>(
    options: Options<GetCandidateWorkExperienceHistoryData, ThrowOnError>,
): RequestResult<
    GetCandidateWorkExperienceHistoryResponses,
    GetCandidateWorkExperienceHistoryErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetCandidateWorkExperienceHistoryResponses,
        GetCandidateWorkExperienceHistoryErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetCandidateWorkExperienceHistoryPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zGetCandidateWorkExperienceHistoryResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/entity-history/candidate-work-experience/{id}',
        ...options,
    });

/**
 * Get contractor health history for a contract
 */
export const getContractorHealthHistory = <ThrowOnError extends boolean = false>(
    options: Options<GetContractorHealthHistoryData, ThrowOnError>,
): RequestResult<
    GetContractorHealthHistoryResponses,
    GetContractorHealthHistoryErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetContractorHealthHistoryResponses,
        GetContractorHealthHistoryErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetContractorHealthHistoryPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zGetContractorHealthHistoryResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/entity-history/contractor-health/{id}',
        ...options,
    });

/**
 * Get stage change history for a customer
 */
export const getCustomerStageHistory = <ThrowOnError extends boolean = false>(
    options: Options<GetCustomerStageHistoryData, ThrowOnError>,
): RequestResult<
    GetCustomerStageHistoryResponses,
    GetCustomerStageHistoryErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetCustomerStageHistoryResponses,
        GetCustomerStageHistoryErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetCustomerStageHistoryPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetCustomerStageHistoryResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/entity-history/customer-stage/{id}',
        ...options,
    });

/**
 * Get company owner change history for a job opening
 */
export const getJobOpeningCompanyOwnerHistory = <ThrowOnError extends boolean = false>(
    options: Options<GetJobOpeningCompanyOwnerHistoryData, ThrowOnError>,
): RequestResult<
    GetJobOpeningCompanyOwnerHistoryResponses,
    GetJobOpeningCompanyOwnerHistoryErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetJobOpeningCompanyOwnerHistoryResponses,
        GetJobOpeningCompanyOwnerHistoryErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetJobOpeningCompanyOwnerHistoryPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zGetJobOpeningCompanyOwnerHistoryResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/entity-history/job-opening-company-owner/{id}',
        ...options,
    });

/**
 * Get health change history for a job opening
 */
export const getJobOpeningHealthHistory = <ThrowOnError extends boolean = false>(
    options: Options<GetJobOpeningHealthHistoryData, ThrowOnError>,
): RequestResult<
    GetJobOpeningHealthHistoryResponses,
    GetJobOpeningHealthHistoryErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetJobOpeningHealthHistoryResponses,
        GetJobOpeningHealthHistoryErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetJobOpeningHealthHistoryPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zGetJobOpeningHealthHistoryResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/entity-history/job-opening-health/{id}',
        ...options,
    });

/**
 * Get payment attempt history for a payment
 */
export const getPaymentAttemptHistory = <ThrowOnError extends boolean = false>(
    options: Options<GetPaymentAttemptHistoryData, ThrowOnError>,
): RequestResult<
    GetPaymentAttemptHistoryResponses,
    GetPaymentAttemptHistoryErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetPaymentAttemptHistoryResponses,
        GetPaymentAttemptHistoryErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetPaymentAttemptHistoryPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetPaymentAttemptHistoryResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/entity-history/payment-attempt/{id}',
        ...options,
    });

/**
 * Create an equipment
 */
export const createEquipment = <ThrowOnError extends boolean = false>(
    options: Options<CreateEquipmentData, ThrowOnError>,
): RequestResult<CreateEquipmentResponses, CreateEquipmentErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<
        CreateEquipmentResponses,
        CreateEquipmentErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zCreateEquipmentBody,
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zCreateEquipmentResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/equipment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Record an approval of an equipment quote given by the client outside the platform
 */
export const recordEquipmentQuoteApproval = <ThrowOnError extends boolean = false>(
    options: Options<RecordEquipmentQuoteApprovalData, ThrowOnError>,
): RequestResult<
    RecordEquipmentQuoteApprovalResponses,
    RecordEquipmentQuoteApprovalErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).post<
        RecordEquipmentQuoteApprovalResponses,
        RecordEquipmentQuoteApprovalErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zRecordEquipmentQuoteApprovalBody,
                    path: zRecordEquipmentQuoteApprovalPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/equipment/quotes/{id}/record-approval',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Get the shipping info of an equipment quote of the authenticated user
 */
export const getEquipmentQuoteShippingInfo = <ThrowOnError extends boolean = false>(
    options: Options<GetEquipmentQuoteShippingInfoData, ThrowOnError>,
): RequestResult<
    GetEquipmentQuoteShippingInfoResponses,
    GetEquipmentQuoteShippingInfoErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetEquipmentQuoteShippingInfoResponses,
        GetEquipmentQuoteShippingInfoErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetEquipmentQuoteShippingInfoPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zGetEquipmentQuoteShippingInfoResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/equipment/quotes/{id}/shipping-info',
        ...options,
    });

/**
 * Confirm the shipping info of an equipment quote of the authenticated user
 */
export const confirmEquipmentQuoteShippingInfo = <ThrowOnError extends boolean = false>(
    options: Options<ConfirmEquipmentQuoteShippingInfoData, ThrowOnError>,
): RequestResult<
    ConfirmEquipmentQuoteShippingInfoResponses,
    ConfirmEquipmentQuoteShippingInfoErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).post<
        ConfirmEquipmentQuoteShippingInfoResponses,
        ConfirmEquipmentQuoteShippingInfoErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zConfirmEquipmentQuoteShippingInfoBody,
                    path: zConfirmEquipmentQuoteShippingInfoPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/equipment/quotes/{id}/shipping-info',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Get an equipment
 */
export const getEquipment = <ThrowOnError extends boolean = false>(
    options: Options<GetEquipmentData, ThrowOnError>,
): RequestResult<GetEquipmentResponses, GetEquipmentErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<GetEquipmentResponses, GetEquipmentErrors, ThrowOnError, 'data'>(
        {
            requestValidator: async (data) =>
                await z
                    .object({
                        body: z.never().optional(),
                        path: zGetEquipmentPath,
                        query: z.never().optional(),
                    })
                    .parseAsync(data),
            responseValidator: async (data) => await zGetEquipmentResponse.parseAsync(data),
            responseStyle: 'data',
            url: '/equipment/{id}',
            ...options,
        },
    );

/**
 * Update an equipment
 */
export const updateEquipment = <ThrowOnError extends boolean = false>(
    options: Options<UpdateEquipmentData, ThrowOnError>,
): RequestResult<UpdateEquipmentResponses, UpdateEquipmentErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).put<
        UpdateEquipmentResponses,
        UpdateEquipmentErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateEquipmentBody,
                    path: zUpdateEquipmentPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zUpdateEquipmentResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/equipment/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Get the health insurance plan of a given type
 */
export const getHealthInsurancePlan = <ThrowOnError extends boolean = false>(
    options: Options<GetHealthInsurancePlanData, ThrowOnError>,
): RequestResult<
    GetHealthInsurancePlanResponses,
    GetHealthInsurancePlanErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetHealthInsurancePlanResponses,
        GetHealthInsurancePlanErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetHealthInsurancePlanPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetHealthInsurancePlanResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/health-insurance/plans/{type}',
        ...options,
    });

/**
 * Preview how a bulk WhatsApp send would be scheduled without sending
 */
export const imBulkPreflight = <ThrowOnError extends boolean = false>(
    options: Options<ImBulkPreflightData, ThrowOnError>,
): RequestResult<ImBulkPreflightResponses, ImBulkPreflightErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<
        ImBulkPreflightResponses,
        ImBulkPreflightErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zImBulkPreflightBody,
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zImBulkPreflightResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/im/bulk-preflight',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Send a WhatsApp template message to a list of candidates
 */
export const imBulkSend = <ThrowOnError extends boolean = false>(
    options: Options<ImBulkSendData, ThrowOnError>,
): RequestResult<ImBulkSendResponses, ImBulkSendErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<ImBulkSendResponses, ImBulkSendErrors, ThrowOnError, 'data'>({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zImBulkSendBody,
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zImBulkSendResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/im/bulk-send',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Expand the candidate pool by applying expansions
 */
export const expandJob = <ThrowOnError extends boolean = false>(
    options: Options<ExpandJobData, ThrowOnError>,
): RequestResult<ExpandJobResponses, ExpandJobErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<ExpandJobResponses, ExpandJobErrors, ThrowOnError, 'data'>({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zExpandJobBody,
                    path: zExpandJobPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zExpandJobResponse2.parseAsync(data),
        responseStyle: 'data',
        url: '/jobs/{id}/expand',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Preview how many candidates each expansion would add
 */
export const getJobExpansionPreview = <ThrowOnError extends boolean = false>(
    options: Options<GetJobExpansionPreviewData, ThrowOnError>,
): RequestResult<
    GetJobExpansionPreviewResponses,
    GetJobExpansionPreviewErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetJobExpansionPreviewResponses,
        GetJobExpansionPreviewErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetJobExpansionPreviewPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetJobExpansionPreviewResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/jobs/{id}/expand/preview',
        ...options,
    });

/**
 * List ops approval items
 */
export const listOpsApprovals = <ThrowOnError extends boolean = false>(
    options?: Options<ListOpsApprovalsData, ThrowOnError>,
): RequestResult<ListOpsApprovalsResponses, ListOpsApprovalsErrors, ThrowOnError, 'data'> =>
    (options?.client ?? client).get<
        ListOpsApprovalsResponses,
        ListOpsApprovalsErrors,
        ThrowOnError,
        'data'
    >({
        querySerializer: { parameters: { types: { array: { explode: false } } } },
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: z.never().optional(),
                    query: zListOpsApprovalsQuery.optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zListOpsApprovalsResponse2.parseAsync(data),
        responseStyle: 'data',
        url: '/ops-approvals',
        ...options,
    });

/**
 * Get a single ops approval item
 */
export const getOpsApproval = <ThrowOnError extends boolean = false>(
    options: Options<GetOpsApprovalData, ThrowOnError>,
): RequestResult<GetOpsApprovalResponses, GetOpsApprovalErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        GetOpsApprovalResponses,
        GetOpsApprovalErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetOpsApprovalPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetOpsApprovalResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/ops-approvals/{id}',
        ...options,
    });

/**
 * Approve an ops approval item
 */
export const approveOpsApproval = <ThrowOnError extends boolean = false>(
    options: Options<ApproveOpsApprovalData, ThrowOnError>,
): RequestResult<ApproveOpsApprovalResponses, ApproveOpsApprovalErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<
        ApproveOpsApprovalResponses,
        ApproveOpsApprovalErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zApproveOpsApprovalPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/ops-approvals/{id}/approve',
        ...options,
    });

/**
 * Reject an ops approval item
 */
export const rejectOpsApproval = <ThrowOnError extends boolean = false>(
    options: Options<RejectOpsApprovalData, ThrowOnError>,
): RequestResult<RejectOpsApprovalResponses, RejectOpsApprovalErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<
        RejectOpsApprovalResponses,
        RejectOpsApprovalErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zRejectOpsApprovalBody,
                    path: zRejectOpsApprovalPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/ops-approvals/{id}/reject',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Recalculate the candidate score
 */
export const rescoreProspect = <ThrowOnError extends boolean = false>(
    options: Options<RescoreProspectData, ThrowOnError>,
): RequestResult<RescoreProspectResponses, RescoreProspectErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<
        RescoreProspectResponses,
        RescoreProspectErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zRescoreProspectPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zRescoreProspectResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/prospects/{id}/rescore',
        ...options,
    });

/**
 * List bank accounts for the authenticated user
 */
export const listBankAccounts = <ThrowOnError extends boolean = false>(
    options?: Options<ListBankAccountsData, ThrowOnError>,
): RequestResult<ListBankAccountsResponses, ListBankAccountsErrors, ThrowOnError, 'data'> =>
    (options?.client ?? client).get<
        ListBankAccountsResponses,
        ListBankAccountsErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zListBankAccountsResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/user/bank-accounts',
        ...options,
    });

/**
 * Create a bank account
 */
export const createBankAccount = <ThrowOnError extends boolean = false>(
    options: Options<CreateBankAccountData, ThrowOnError>,
): RequestResult<CreateBankAccountResponses, CreateBankAccountErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<
        CreateBankAccountResponses,
        CreateBankAccountErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zCreateBankAccountBody,
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zCreateBankAccountResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/user/bank-accounts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Check if a bank account name matches a contracting entity
 */
export const checkBankAccountName = <ThrowOnError extends boolean = false>(
    options: Options<CheckBankAccountNameData, ThrowOnError>,
): RequestResult<CheckBankAccountNameResponses, CheckBankAccountNameErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<
        CheckBankAccountNameResponses,
        CheckBankAccountNameErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zCheckBankAccountNameBody,
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zCheckBankAccountNameResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/user/bank-accounts/check-name',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Delete a bank account
 */
export const deleteBankAccount = <ThrowOnError extends boolean = false>(
    options: Options<DeleteBankAccountData, ThrowOnError>,
): RequestResult<DeleteBankAccountResponses, DeleteBankAccountErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).delete<
        DeleteBankAccountResponses,
        DeleteBankAccountErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zDeleteBankAccountPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zDeleteBankAccountResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/user/bank-accounts/{id}',
        ...options,
    });

/**
 * Get a bank account
 */
export const getBankAccount = <ThrowOnError extends boolean = false>(
    options: Options<GetBankAccountData, ThrowOnError>,
): RequestResult<GetBankAccountResponses, GetBankAccountErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        GetBankAccountResponses,
        GetBankAccountErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetBankAccountPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetBankAccountResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/user/bank-accounts/{id}',
        ...options,
    });

/**
 * Update a bank account
 */
export const updateBankAccount = <ThrowOnError extends boolean = false>(
    options: Options<UpdateBankAccountData, ThrowOnError>,
): RequestResult<UpdateBankAccountResponses, UpdateBankAccountErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).patch<
        UpdateBankAccountResponses,
        UpdateBankAccountErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateBankAccountBody,
                    path: zUpdateBankAccountPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zUpdateBankAccountResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/user/bank-accounts/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Set a bank account as default
 */
export const setDefaultBankAccount = <ThrowOnError extends boolean = false>(
    options: Options<SetDefaultBankAccountData, ThrowOnError>,
): RequestResult<
    SetDefaultBankAccountResponses,
    SetDefaultBankAccountErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).post<
        SetDefaultBankAccountResponses,
        SetDefaultBankAccountErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zSetDefaultBankAccountPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zSetDefaultBankAccountResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/user/bank-accounts/{id}/set-default',
        ...options,
    });

/**
 * Request a country change for the authenticated user
 */
export const changeCountry = <ThrowOnError extends boolean = false>(
    options: Options<ChangeCountryData, ThrowOnError>,
): RequestResult<ChangeCountryResponses, ChangeCountryErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).post<
        ChangeCountryResponses,
        ChangeCountryErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zChangeCountryBody,
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/user/change-country',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * List contracting entities for the authenticated user
 */
export const listContractingEntities = <ThrowOnError extends boolean = false>(
    options?: Options<ListContractingEntitiesData, ThrowOnError>,
): RequestResult<
    ListContractingEntitiesResponses,
    ListContractingEntitiesErrors,
    ThrowOnError,
    'data'
> =>
    (options?.client ?? client).get<
        ListContractingEntitiesResponses,
        ListContractingEntitiesErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zListContractingEntitiesResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/user/contracting-entities',
        ...options,
    });

/**
 * Create a contracting entity
 */
export const createContractingEntity = <ThrowOnError extends boolean = false>(
    options: Options<CreateContractingEntityData, ThrowOnError>,
): RequestResult<
    CreateContractingEntityResponses,
    CreateContractingEntityErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).post<
        CreateContractingEntityResponses,
        CreateContractingEntityErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zCreateContractingEntityBody,
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zCreateContractingEntityResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/user/contracting-entities',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Create a new business entity and fulfill the pending selection
 */
export const selectNewContractingEntity = <ThrowOnError extends boolean = false>(
    options: Options<SelectNewContractingEntityData, ThrowOnError>,
): RequestResult<
    SelectNewContractingEntityResponses,
    SelectNewContractingEntityErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).post<
        SelectNewContractingEntityResponses,
        SelectNewContractingEntityErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zSelectNewContractingEntityBody,
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zSelectNewContractingEntityResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/user/contracting-entities/select/new',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Select an existing entity and fulfill the pending selection
 */
export const selectExistingContractingEntity = <ThrowOnError extends boolean = false>(
    options: Options<SelectExistingContractingEntityData, ThrowOnError>,
): RequestResult<
    SelectExistingContractingEntityResponses,
    SelectExistingContractingEntityErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).post<
        SelectExistingContractingEntityResponses,
        SelectExistingContractingEntityErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zSelectExistingContractingEntityBody,
                    path: zSelectExistingContractingEntityPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zSelectExistingContractingEntityResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/user/contracting-entities/select/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Get a single contracting entity that belongs to the user
 */
export const getContractingEntity = <ThrowOnError extends boolean = false>(
    options: Options<GetContractingEntityData, ThrowOnError>,
): RequestResult<GetContractingEntityResponses, GetContractingEntityErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        GetContractingEntityResponses,
        GetContractingEntityErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetContractingEntityPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetContractingEntityResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/user/contracting-entities/{id}',
        ...options,
    });

/**
 * Update a contracting entity
 */
export const updateContractingEntity = <ThrowOnError extends boolean = false>(
    options: Options<UpdateContractingEntityData, ThrowOnError>,
): RequestResult<
    UpdateContractingEntityResponses,
    UpdateContractingEntityErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).patch<
        UpdateContractingEntityResponses,
        UpdateContractingEntityErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateContractingEntityBody,
                    path: zUpdateContractingEntityPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zUpdateContractingEntityResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/user/contracting-entities/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Assign a contracting entity to the user's current contract
 */
export const assignContractingEntity = <ThrowOnError extends boolean = false>(
    options: Options<AssignContractingEntityData, ThrowOnError>,
): RequestResult<
    AssignContractingEntityResponses,
    AssignContractingEntityErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).post<
        AssignContractingEntityResponses,
        AssignContractingEntityErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zAssignContractingEntityPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zAssignContractingEntityResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/user/contracting-entities/{id}/assign',
        ...options,
    });

/**
 * Request the deletion of the authenticated user's data
 */
export const requestUserDeletion = <ThrowOnError extends boolean = false>(
    options?: Options<RequestUserDeletionData, ThrowOnError>,
): RequestResult<RequestUserDeletionResponses, RequestUserDeletionErrors, ThrowOnError, 'data'> =>
    (options?.client ?? client).post<
        RequestUserDeletionResponses,
        RequestUserDeletionErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/user/deletion-request',
        ...options,
    });

/**
 * Upload a document to the authenticated user's profile
 */
export const uploadUserDocument = <ThrowOnError extends boolean = false>(
    options?: Options<UploadUserDocumentData, ThrowOnError>,
): RequestResult<UploadUserDocumentResponses, UploadUserDocumentErrors, ThrowOnError, 'data'> =>
    (options?.client ?? client).post<
        UploadUserDocumentResponses,
        UploadUserDocumentErrors,
        ThrowOnError,
        'data'
    >({
        ...formDataBodySerializer,
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUploadUserDocumentBody.optional(),
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zUploadUserDocumentResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/user/document',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers,
        },
    });

/**
 * Get the user's current job details
 */
export const getUserJobDetails = <ThrowOnError extends boolean = false>(
    options?: Options<GetUserJobDetailsData, ThrowOnError>,
): RequestResult<GetUserJobDetailsResponses, GetUserJobDetailsErrors, ThrowOnError, 'data'> =>
    (options?.client ?? client).get<
        GetUserJobDetailsResponses,
        GetUserJobDetailsErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetUserJobDetailsResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/user/job-details',
        ...options,
    });

/**
 * Request a legal name change for the authenticated user
 */
export const changeLegalName = <ThrowOnError extends boolean = false>(
    options?: Options<ChangeLegalNameData, ThrowOnError>,
): RequestResult<ChangeLegalNameResponses, ChangeLegalNameErrors, ThrowOnError, 'data'> =>
    (options?.client ?? client).post<
        ChangeLegalNameResponses,
        ChangeLegalNameErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/user/legal-name-change',
        ...options,
    });

/**
 * Get the authenticated user's location
 */
export const getLocation = <ThrowOnError extends boolean = false>(
    options?: Options<GetLocationData, ThrowOnError>,
): RequestResult<GetLocationResponses, GetLocationErrors, ThrowOnError, 'data'> =>
    (options?.client ?? client).get<GetLocationResponses, GetLocationErrors, ThrowOnError, 'data'>({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetLocationResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/user/location',
        ...options,
    });

/**
 * Update the authenticated user's location
 */
export const updateLocation = <ThrowOnError extends boolean = false>(
    options: Options<UpdateLocationData, ThrowOnError>,
): RequestResult<UpdateLocationResponses, UpdateLocationErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).patch<
        UpdateLocationResponses,
        UpdateLocationErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateLocationBody,
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/user/location',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Get the authenticated user's pending profile changes
 */
export const getUserPendingChanges = <ThrowOnError extends boolean = false>(
    options?: Options<GetUserPendingChangesData, ThrowOnError>,
): RequestResult<
    GetUserPendingChangesResponses,
    GetUserPendingChangesErrors,
    ThrowOnError,
    'data'
> =>
    (options?.client ?? client).get<
        GetUserPendingChangesResponses,
        GetUserPendingChangesErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetUserPendingChangesResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/user/pending-changes',
        ...options,
    });

/**
 * Upload the authenticated user's profile picture
 */
export const uploadUserPicture = <ThrowOnError extends boolean = false>(
    options?: Options<UploadUserPictureData, ThrowOnError>,
): RequestResult<UploadUserPictureResponses, UploadUserPictureErrors, ThrowOnError, 'data'> =>
    (options?.client ?? client).post<
        UploadUserPictureResponses,
        UploadUserPictureErrors,
        ThrowOnError,
        'data'
    >({
        ...formDataBodySerializer,
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUploadUserPictureBody.optional(),
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zUploadUserPictureResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/user/picture',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers,
        },
    });

/**
 * Get the authenticated user's profile
 */
export const getUserProfile = <ThrowOnError extends boolean = false>(
    options?: Options<GetUserProfileData, ThrowOnError>,
): RequestResult<GetUserProfileResponses, GetUserProfileErrors, ThrowOnError, 'data'> =>
    (options?.client ?? client).get<
        GetUserProfileResponses,
        GetUserProfileErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetUserProfileResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/user/profile',
        ...options,
    });

/**
 * Notify the user wants to change their salary
 */
export const requestSalaryChange = <ThrowOnError extends boolean = false>(
    options?: Options<RequestSalaryChangeData, ThrowOnError>,
): RequestResult<RequestSalaryChangeResponses, RequestSalaryChangeErrors, ThrowOnError, 'data'> =>
    (options?.client ?? client).post<
        RequestSalaryChangeResponses,
        RequestSalaryChangeErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zRequestSalaryChangeResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/user/request-salary-change',
        ...options,
    });

/**
 * Get the authenticated user's equipment shipping info
 */
export const getUserShippingInfo = <ThrowOnError extends boolean = false>(
    options?: Options<GetUserShippingInfoData, ThrowOnError>,
): RequestResult<GetUserShippingInfoResponses, GetUserShippingInfoErrors, ThrowOnError, 'data'> =>
    (options?.client ?? client).get<
        GetUserShippingInfoResponses,
        GetUserShippingInfoErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetUserShippingInfoResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/user/shipping-info',
        ...options,
    });

/**
 * Confirm the authenticated user's equipment shipping info
 */
export const confirmUserShippingInfo = <ThrowOnError extends boolean = false>(
    options: Options<ConfirmUserShippingInfoData, ThrowOnError>,
): RequestResult<
    ConfirmUserShippingInfoResponses,
    ConfirmUserShippingInfoErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).post<
        ConfirmUserShippingInfoResponses,
        ConfirmUserShippingInfoErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zConfirmUserShippingInfoBody,
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/user/shipping-info',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Update the authenticated user's target salary
 */
export const updateUserTargetSalary = <ThrowOnError extends boolean = false>(
    options: Options<UpdateUserTargetSalaryData, ThrowOnError>,
): RequestResult<
    UpdateUserTargetSalaryResponses,
    UpdateUserTargetSalaryErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).patch<
        UpdateUserTargetSalaryResponses,
        UpdateUserTargetSalaryErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateUserTargetSalaryBody,
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/user/target-salary',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Get the authenticated user's work profile
 */
export const getUserWorkProfile = <ThrowOnError extends boolean = false>(
    options?: Options<GetUserWorkProfileData, ThrowOnError>,
): RequestResult<GetUserWorkProfileResponses, GetUserWorkProfileErrors, ThrowOnError, 'data'> =>
    (options?.client ?? client).get<
        GetUserWorkProfileResponses,
        GetUserWorkProfileErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetUserWorkProfileResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/user/work-profile',
        ...options,
    });

/**
 * Update the authenticated user's work profile
 */
export const updateUserWorkProfile = <ThrowOnError extends boolean = false>(
    options: Options<UpdateUserWorkProfileData, ThrowOnError>,
): RequestResult<
    UpdateUserWorkProfileResponses,
    UpdateUserWorkProfileErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).patch<
        UpdateUserWorkProfileResponses,
        UpdateUserWorkProfileErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateUserWorkProfileBody,
                    path: z.never().optional(),
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/user/work-profile',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * List bank accounts for an user
 */
export const listUserBankAccounts = <ThrowOnError extends boolean = false>(
    options: Options<ListUserBankAccountsData, ThrowOnError>,
): RequestResult<ListUserBankAccountsResponses, ListUserBankAccountsErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        ListUserBankAccountsResponses,
        ListUserBankAccountsErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zListUserBankAccountsPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zListUserBankAccountsResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/users/{id}/bank-accounts',
        ...options,
    });

/**
 * Get certifications for the user
 */
export const getUserCertifications = <ThrowOnError extends boolean = false>(
    options: Options<GetUserCertificationsData, ThrowOnError>,
): RequestResult<
    GetUserCertificationsResponses,
    GetUserCertificationsErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetUserCertificationsResponses,
        GetUserCertificationsErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetUserCertificationsPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetUserCertificationsResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/users/{id}/certifications',
        ...options,
    });

/**
 * Update certifications for the user
 */
export const updateUserCertifications = <ThrowOnError extends boolean = false>(
    options: Options<UpdateUserCertificationsData, ThrowOnError>,
): RequestResult<
    UpdateUserCertificationsResponses,
    UpdateUserCertificationsErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).patch<
        UpdateUserCertificationsResponses,
        UpdateUserCertificationsErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateUserCertificationsBody,
                    path: zUpdateUserCertificationsPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/users/{id}/certifications',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Get a user's contact info
 */
export const getUserContactInfo = <ThrowOnError extends boolean = false>(
    options: Options<GetUserContactInfoData, ThrowOnError>,
): RequestResult<GetUserContactInfoResponses, GetUserContactInfoErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        GetUserContactInfoResponses,
        GetUserContactInfoErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetUserContactInfoPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetUserContactInfoResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/users/{id}/contact-info',
        ...options,
    });

/**
 * Update a user's contact info
 */
export const updateUserContactInfo = <ThrowOnError extends boolean = false>(
    options: Options<UpdateUserContactInfoData, ThrowOnError>,
): RequestResult<
    UpdateUserContactInfoResponses,
    UpdateUserContactInfoErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).patch<
        UpdateUserContactInfoResponses,
        UpdateUserContactInfoErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateUserContactInfoBody,
                    path: zUpdateUserContactInfoPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/users/{id}/contact-info',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * List contracting entities for a given user (Remotely only)
 */
export const listUserContractingEntities = <ThrowOnError extends boolean = false>(
    options: Options<ListUserContractingEntitiesData, ThrowOnError>,
): RequestResult<
    ListUserContractingEntitiesResponses,
    ListUserContractingEntitiesErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        ListUserContractingEntitiesResponses,
        ListUserContractingEntitiesErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zListUserContractingEntitiesPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zListUserContractingEntitiesResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/users/{id}/contracting-entities',
        ...options,
    });

/**
 * Returns the latest unused contracting entity selection made by the contractor
 */
export const getContractingEntitySelection = <ThrowOnError extends boolean = false>(
    options: Options<GetContractingEntitySelectionData, ThrowOnError>,
): RequestResult<
    GetContractingEntitySelectionResponses,
    GetContractingEntitySelectionErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetContractingEntitySelectionResponses,
        GetContractingEntitySelectionErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetContractingEntitySelectionPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zGetContractingEntitySelectionResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/users/{id}/contracting-entities/selection',
        ...options,
    });

/**
 * Request a contracting entity selection from a candidate (Remotely only)
 */
export const requestContractingEntitySelection = <ThrowOnError extends boolean = false>(
    options: Options<RequestContractingEntitySelectionData, ThrowOnError>,
): RequestResult<
    RequestContractingEntitySelectionResponses,
    RequestContractingEntitySelectionErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).post<
        RequestContractingEntitySelectionResponses,
        RequestContractingEntitySelectionErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zRequestContractingEntitySelectionBody,
                    path: zRequestContractingEntitySelectionPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/users/{id}/contracting-entities/selection',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Returns the status of the latest unused entity selection
 */
export const getContractingEntitySelectionStatus = <ThrowOnError extends boolean = false>(
    options: Options<GetContractingEntitySelectionStatusData, ThrowOnError>,
): RequestResult<
    GetContractingEntitySelectionStatusResponses,
    GetContractingEntitySelectionStatusErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).get<
        GetContractingEntitySelectionStatusResponses,
        GetContractingEntitySelectionStatusErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetContractingEntitySelectionStatusPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) =>
            await zGetContractingEntitySelectionStatusResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/users/{id}/contracting-entities/selection/status',
        ...options,
    });

/**
 * List a contractor's contracts
 */
export const listUserContracts = <ThrowOnError extends boolean = false>(
    options: Options<ListUserContractsData, ThrowOnError>,
): RequestResult<ListUserContractsResponses, ListUserContractsErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        ListUserContractsResponses,
        ListUserContractsErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zListUserContractsPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zListUserContractsResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/users/{id}/contracts',
        ...options,
    });

/**
 * List a contractor's documents
 */
export const listUserDocuments = <ThrowOnError extends boolean = false>(
    options: Options<ListUserDocumentsData, ThrowOnError>,
): RequestResult<ListUserDocumentsResponses, ListUserDocumentsErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        ListUserDocumentsResponses,
        ListUserDocumentsErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zListUserDocumentsPath,
                    query: zListUserDocumentsQuery.optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zListUserDocumentsResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/users/{id}/documents',
        ...options,
    });

/**
 * Get a user's personal info
 */
export const getUserPersonalInfo = <ThrowOnError extends boolean = false>(
    options: Options<GetUserPersonalInfoData, ThrowOnError>,
): RequestResult<GetUserPersonalInfoResponses, GetUserPersonalInfoErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        GetUserPersonalInfoResponses,
        GetUserPersonalInfoErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetUserPersonalInfoPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetUserPersonalInfoResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/users/{id}/personal-info',
        ...options,
    });

/**
 * Update a user's personal info
 */
export const updateUserPersonalInfo = <ThrowOnError extends boolean = false>(
    options: Options<UpdateUserPersonalInfoData, ThrowOnError>,
): RequestResult<
    UpdateUserPersonalInfoResponses,
    UpdateUserPersonalInfoErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).patch<
        UpdateUserPersonalInfoResponses,
        UpdateUserPersonalInfoErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateUserPersonalInfoBody,
                    path: zUpdateUserPersonalInfoPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/users/{id}/personal-info',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Get a user's scheduling URL
 */
export const getUserSchedulingUrl = <ThrowOnError extends boolean = false>(
    options: Options<GetUserSchedulingUrlData, ThrowOnError>,
): RequestResult<GetUserSchedulingUrlResponses, GetUserSchedulingUrlErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        GetUserSchedulingUrlResponses,
        GetUserSchedulingUrlErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetUserSchedulingUrlPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetUserSchedulingUrlResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/users/{id}/scheduling-url',
        ...options,
    });

/**
 * Update a user's scheduling URL
 */
export const updateUserSchedulingUrl = <ThrowOnError extends boolean = false>(
    options: Options<UpdateUserSchedulingUrlData, ThrowOnError>,
): RequestResult<
    UpdateUserSchedulingUrlResponses,
    UpdateUserSchedulingUrlErrors,
    ThrowOnError,
    'data'
> =>
    (options.client ?? client).patch<
        UpdateUserSchedulingUrlResponses,
        UpdateUserSchedulingUrlErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateUserSchedulingUrlBody,
                    path: zUpdateUserSchedulingUrlPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/users/{id}/scheduling-url',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Get a contractor's seniority level and who last changed it
 */
export const getUserSeniority = <ThrowOnError extends boolean = false>(
    options: Options<GetUserSeniorityData, ThrowOnError>,
): RequestResult<GetUserSeniorityResponses, GetUserSeniorityErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        GetUserSeniorityResponses,
        GetUserSeniorityErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetUserSeniorityPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetUserSeniorityResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/users/{id}/seniority',
        ...options,
    });

/**
 * Update a contractor's seniority level
 */
export const updateUserSeniority = <ThrowOnError extends boolean = false>(
    options: Options<UpdateUserSeniorityData, ThrowOnError>,
): RequestResult<UpdateUserSeniorityResponses, UpdateUserSeniorityErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).patch<
        UpdateUserSeniorityResponses,
        UpdateUserSeniorityErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateUserSeniorityBody,
                    path: zUpdateUserSeniorityPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/users/{id}/seniority',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

/**
 * Get a user's work info
 */
export const getUserWorkInfo = <ThrowOnError extends boolean = false>(
    options: Options<GetUserWorkInfoData, ThrowOnError>,
): RequestResult<GetUserWorkInfoResponses, GetUserWorkInfoErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).get<
        GetUserWorkInfoResponses,
        GetUserWorkInfoErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: z.never().optional(),
                    path: zGetUserWorkInfoPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseValidator: async (data) => await zGetUserWorkInfoResponse.parseAsync(data),
        responseStyle: 'data',
        url: '/users/{id}/work-info',
        ...options,
    });

/**
 * Update a user's work info
 */
export const updateUserWorkInfo = <ThrowOnError extends boolean = false>(
    options: Options<UpdateUserWorkInfoData, ThrowOnError>,
): RequestResult<UpdateUserWorkInfoResponses, UpdateUserWorkInfoErrors, ThrowOnError, 'data'> =>
    (options.client ?? client).patch<
        UpdateUserWorkInfoResponses,
        UpdateUserWorkInfoErrors,
        ThrowOnError,
        'data'
    >({
        requestValidator: async (data) =>
            await z
                .object({
                    body: zUpdateUserWorkInfoBody,
                    path: zUpdateUserWorkInfoPath,
                    query: z.never().optional(),
                })
                .parseAsync(data),
        responseStyle: 'data',
        url: '/users/{id}/work-info',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
